import { Component, OnInit, Input, ViewChild, OnChanges, AfterViewInit, Output, EventEmitter, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { DeviceService } from '../../device.service';
import { UsersService } from 'src/app/users/users.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import * as lo from 'lodash-es';
import * as _ from 'underscore';
import { LoaderInterceptorService } from 'src/app/shared/loader/loader-interceptor.service';
import truckTypes from 'src/app/shared/lists/truck_type.json';
import truckManufacturers from 'src/app/shared/lists/truck_manufacturer.json';
import { DeviceCommonService } from '../../device-common.service';
import { mainDeviceConfig } from '../../device-factory/device-config';
import { DeviceFactory } from '../../device-factory/device-factory';
import { IotahDevice } from '../../device-factory/Iotah-device';
import { Subscription, of } from 'rxjs';
import { SitesService } from 'src/app/sites/sites.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { FormComponent } from 'src/app/shared/form/form.component';
import { DeviceTypeService } from '../../device-type.service';
import { shiftScheduleOptions } from '../../../site-settings/site-utilization-settings/site-utilization-settings.interface';
import { AdminService } from 'src/app/admin/admin.service';
import { ChargerManufacturer, ChargerManufacturersService } from 'src/app/noc-tools/charger-manufacturers/charger-manufacturers.service';
import { saveAs } from 'file-saver';

const LEAD_ACID_OVERVOLTAGE_LIMIT = 2.7;
const LITHIUM_OVERVOLTAGE_LIMIT = 5;
const overvoltageLimitDefaults: { [key: number]: number } = {
	[DeviceFactory.types.battlink]: LEAD_ACID_OVERVOLTAGE_LIMIT,
	[DeviceFactory.types.battlinkII]: LEAD_ACID_OVERVOLTAGE_LIMIT,
	[DeviceFactory.types.charglink]: LEAD_ACID_OVERVOLTAGE_LIMIT,
	[DeviceFactory.types.brm]: LEAD_ACID_OVERVOLTAGE_LIMIT,
	[DeviceFactory.types.lithiumBattlink]: LITHIUM_OVERVOLTAGE_LIMIT,
};

@Component({
	selector: 'app-device-settings',
	templateUrl: './device-settings.component.html',
	styleUrls: ['./device-settings.component.css']
})
export class DeviceSettingsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

	@Input() device: any = {};
	@Input() config_info: any = {};
	@Input() multiDevices: boolean = false;
	@Input() deviceIds: any = '';
	@Input() currentSite: any;
	@Input() enterprisePermissions: any = {};
	@Input() changesStack: any = {};
	@Output() updateDeviceAttributes = new EventEmitter<any>();
	@Output() onDeviceDataChange = new EventEmitter<Object>();
	@ViewChild('cardContainer', { static: false }) cardContainer?: ElementRef;
	@ViewChild("saveOptionsModal") saveOptionsModal?: ModalComponent;
	@ViewChild("deviceWithoutPasswordModal") deviceWithoutPasswordModal?: ModalComponent;
	@ViewChild("warningsModal") warningsModal?: ModalComponent;
	@ViewChild("changesStackTooltip", { static: true }) changesStackTooltip?: ModalComponent;
	@ViewChild("availableWifiNetworksModal", { static: true }) availableWifiNetworksModal?: ModalComponent;
	@ViewChild("selectWifiNetworksModal", { static: true }) selectWifiNetworksModal?: ModalComponent;
	@ViewChild("deleteChangeStack") deleteChangeStack?: ModalComponent;
	@ViewChild("restartDeviceConfirm") restartDeviceConfirm?: ModalComponent;
	@ViewChild("eventTypeSettingsForm") eventTypeSettingsForm?: FormComponent;
	@ViewChild("revealDevicePasswordConfirmModal") revealDevicePasswordConfirmModal?: ModalComponent;
	@ViewChild("unblockDeviceConnectionConfirm") unblockDeviceConnectionConfirm?: ModalComponent;
	@ViewChild("newPanelIdModal") newPanelIdModal?: ModalComponent;

	doneScrolling = false;
	theUIInitDone = false;

	shipmentLink = null;
	connectivityVerficationLink = null;
	shipmentResults = {
		notTested: 0,
		passed: 1,
		failed: 2
	}

	tab: string = 'info';
	prevTab: string = '';

	cardsVisibility: any = {};
	saveChangesVisibility: any = {};
	oldDevice: any = {};
	dirtyFields: any = {};
	zones: any[] = [];
	lastSavedUser: any;
	lastMaintenanceDateUserUpdate: any;
	zoneId: number;
	forceDirtyFields:any = [];
	validationRules: any;
	deviceWarnings:any = [];
	maintenanceSchedule: any;
	shiftSchedule: any;
	oldMaintenanceSchedule: any = {};
	oldShiftSchedule: any = {};
	hasMaintenance: boolean = false;
	isChargLinkDevice: boolean = false;
	chargLinkTranslationPath: string = "";
	deviceConfig: mainDeviceConfig | null = (new IotahDevice).config;
	readonly chargerManufacturerOtherOption = '__other__';
	chargerManufacturerNames: string[] = null;
	permissionMapperKey: string = '';
	siteID = 0;
	customerID = 0;
	tabs = [
		'info',
		'deviceSettings',
		'batterySettings',
		'cal',
		'networkingSettings',
		'networking',
		'billedKWHrsSettings',
		'maintenanceSchedule',
		'official-reporting',
		'connectivityFrequency',
		'loadScheduling',
		'eventTypeSettings'
	];

	fieldRestartDevice = ['disable_xtra', 'disable_external_rtc', 'hw_version', 'enc_code', 'lte_cellular_bands', 'nbiot_cellular_bands', 'enable_wifi_ap_on_start', 'hall_effect_sensor_type'];
	fieldRestartDeviceOnEnable = [ 'enable_cellular'];
	restartDeviceChangedFields: string[] = [];
	EVENT_TABLE_COLUMNS_KEY = 'table_columns_events';
	infoFormFields: any;
	deviceSettingsFormFields: any;
	batterySettingsFormFields: any;
	calFormFields: any;
	networkingSettingsFormFields: any;
	networkingFormFields: any;
	billedKWHrsSettingsFormFields: any;
	maintenanceScheduleFormFields: any;
	eventTypeSettingsFormFields: any;
	shiftScheduleFormFields : any;
	extraRules: any; //Fields needed for each device (multi settings)
	currentUser: any = {};
	availableWifiNetworks: any = [];
	selectedWifiNetwork: any = {};
	removedChangesStackInfo: any;
	confirmDeleteStack: boolean = false;

	getSitePanelIdsSub!: Subscription;

	readonly addNewPanelIdValue = 'new';
	panelIdOptions: any[] = [
		{ label: this.translate.instant('settings.add_new_panel_id'), value: this.addNewPanelIdValue },
	];
	panelIdCurrentValue = '';
	panelIdLabel = '';
	newPanelId = '';
	newPanelIdError = '';

	rejectionReasons: any = {
		'deviceNotFound': 'rejection_log.device_not_found',
		'serialNumbersMissMatch': 'rejection_log.serial_number_mismatch',
		'hugeQueueSize': 'rejection_log.huge_queue_size',
		'encCodeMissMatch': 'rejection_log.enc_code_miss_match'
	};

	isIMDevice = false;
	hasCalibrationCertificate = false;
	eventTypeSettingsFWDisabled = false;
	minFWVersionToEditEventType = 1.284;
	minFWVersionForMemoryMapFields = 3.019;
	deviceConnectionRejectedresons = null;
	readonly stateBasedEventFields: string[] = [
		'idle_to_consume_power',
		'idle_to_consume_timer',
		'idle_to_generate_power',
		'idle_to_generate_timer',
		'consume_to_idle_power',
		'consume_to_idle_timer',
		'consume_to_generate_power',
		'consume_to_generate_timer',
		'generate_to_idle_power',
		'generate_to_idle_timer',
		'generate_to_consume_power',
		'generate_to_consume_timer',
	];

	restartRequired: boolean = false;
	onCtRatioChangedOldValue = 0;
	lastVoltageRefOption = 0;
	actualVoltageValue = 0;
	defaultWiringMode: number = 1;
	truckUtilizationSettings: any = {};

	readonly adeTypeOptions: { label: string, value: number }[] = [
		{ value: 0, label: 'ADE 9000' },
		{ value: 1, label: 'ADE 9078' },
		{ value: 2, label: 'ADE 7953' },
	];
	readonly selfreqOptions: { value: number, text: string }[] = [
		{ value: 0, text: '50Hz' },
		{ value: 1, text: '60Hz' },
	];
	constructor(
		private route: ActivatedRoute,
		private cookieService: CookieService,
		private deviceService: DeviceService,
		public usersService: UsersService,
		private notificationMessage: NotificationMessageService,
		public commonUtil: CommonService,
		private commonData: CommonDataService,
		private translate: TranslateService,
		private loader: LoaderInterceptorService,
		private deviceCommonService: DeviceCommonService,
		private el: ElementRef,
		private renderer: Renderer2,
		private sitesService: SitesService,
		private deviceTypeService: DeviceTypeService,
		private commonService: CommonService,
		private adminService: AdminService,
		private chargerManufacturersService: ChargerManufacturersService,
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(
			params => {
				this.setTab(params.tab);
			}
		);
		this.siteID = this.route.parent.snapshot.params.siteId || 0;
		this.customerID = this.route.parent.snapshot.params.customerId || 0;

		this.usersService.currentUser.subscribe((user: any) => {
			if(user && user['id']) {
				this.currentUser = user;
				this.theUIInitDone = true;
			}
		});
		this.getSiteUtilizationSettings();

		this.formatBandsFields();
		this.deviceService.formatRtLogFrequencyField(this.device, this.device.rt_log_frequency, false);
		this.deviceService.formatStaticIP(this.device, 'ethernet');

		this.setDeviceConfig(this.device.sct_device_type);
		if(this.usersService.hasAccessFunction('access_rejection_logs'))
			this.getRejectedDeviceConnections();

		if(DeviceFactory.isIMDeviceType(this.device.sct_device_type))
			this.getSitePanelIds();
	}

	getSitePanelIds() {
		this.panelIdCurrentValue = this.device.power_view_sn || '';
		this.panelIdLabel = this.deviceService.translate('devices.panel_id', this.device);

		this.getSitePanelIdsSub = this.sitesService.getSitePanelIds(this.device.site_id, this.device.mac_address).subscribe((res: any) => {
			const panelIds = (res || []).map(panel => panel.panel_id);

			// keep the panel the device is assigned to selectable, even if it is not listed anymore
			if(this.panelIdCurrentValue && !panelIds.includes(this.panelIdCurrentValue))
				panelIds.push(this.panelIdCurrentValue);

			this.setPanelIdOptions([
				{ label: this.translate.instant('settings.add_new_panel_id'), value: this.addNewPanelIdValue },
				...panelIds.map(panelId => ({ label: panelId, value: panelId }))
			]);
		});
	}

	setPanelIdOptions(options: any[]) {
		this.panelIdOptions = options;

		const panelIdField = (this.infoFormFields || []).find(field => field.name == 'power_view_sn');
		if(panelIdField)
			panelIdField.items = this.panelIdOptions;
	}

	onPanelIdChanged(value: string) {
		if(value != this.addNewPanelIdValue)
			return this.panelIdCurrentValue = value;

		this.newPanelId = '';
		this.newPanelIdError = '';
		this.newPanelIdModal?.show();
	}

	panelIdValidation(panelId: string) {
		if(!panelId) {
			this.newPanelIdError = this.translate.instant('g.field_is_required');
			return false;
		}

		const isExisting = this.panelIdOptions.some(option =>
			option.value != this.addNewPanelIdValue && String(option.value).trim().toLowerCase() == panelId.toLowerCase()
		);
		if(isExisting) {
			this.newPanelIdError = this.translate.instant('settings.panel_id_is_exists');
			return false;
		}

		return true;
	}

	addNewPanelId() {
		const panelId = (this.newPanelId || '').trim();
		if(!this.panelIdValidation(panelId))
			return;

		this.sitesService.insertPanel(this.device.site_id, this.device.mac_address, panelId).subscribe(() => {
			this.setPanelIdOptions([...this.panelIdOptions, { label: panelId, value: panelId }]);
			this.panelIdCurrentValue = panelId;
			this.device.power_view_sn = panelId;
			this.forceDirtyFields.push('power_view_sn');
			this.newPanelId = '';
			this.newPanelIdModal?.hide();
		});
	}

	cancelAddNewPanelId() {
		this.device.power_view_sn = this.panelIdCurrentValue;
		this.newPanelId = '';
		this.newPanelIdError = '';
		this.newPanelIdModal?.hide();
	}

	getRejectedDeviceConnections() {
		const criteria = { getBy: 'mac_address', value: this.device.mac_address }
		this.adminService.getRejectedDeviceConnections(criteria).subscribe(
			(response: any) => {
				this.deviceConnectionRejectedresons = [...new Set(response.map(item => this.translate.instant(this.rejectionReasons[item.reason])))].join(', ');
			}
		);
	}

	getSiteUtilizationSettings() {
		this.sitesService.getSiteUtilizationSettings(this.siteID).subscribe((res: any) => {
			const siteUtilizationData = res && res.length ? res[0] : {};
			this.truckUtilizationSettings = siteUtilizationData.truck_utilization_settings;
			return this.sitesService.setUtilizationSettingsCurrentSite(siteUtilizationData);
		});
	}

	// Calibration certificate download on Device Info (ST-2672 / ST-2781): SCT users, IoTAh family, one device only
	checkCalibrationCertificate() {
		this.hasCalibrationCertificate = false;
		const macAddress = this.device.mac_address;
		if (this.multiDevices || !this.usersService.getCurrentUser().isSCT || DeviceFactory.isIMDeviceType(this.device.sct_device_type) || !macAddress)
			return;

		this.deviceService.getCalibrationCertificateStatus(macAddress).subscribe((data) => {
			// ignore a late answer for a device that is no longer selected
			if (macAddress != this.device.mac_address)
				return;

			this.hasCalibrationCertificate = !!data?.available;
		});
	}

	downloadCalibrationCertificate() {
		this.deviceService.downloadCalibrationCertificate(this.device.mac_address).subscribe((data) => {
			if (!data?.content)
				return;

			const blob = new Blob([new Uint8Array(data.content.data)], { type: 'application/pdf' });
			saveAs(blob, data.name);
		});
	}

	get uiStructure() {
		this.isIMDevice = DeviceFactory.isIMDeviceType(this.device.sct_device_type);
		if (this.isIMDevice)
			return this.deviceService.imDeviceSettingsUiStructure;
		return this.deviceService.deviceSettingsUiStructure;
	}

	ngAfterViewChecked(): void {
		if (!this.doneScrolling && this.theUIInitDone && this.cardContainer?.nativeElement?.querySelector('.active'))
			this.doneScrolling = this.commonUtil.scrollToActiveLink(this.cardContainer);
	}

	prepareDeadManCurrentLimitList() {
		let items = [];
		for(let i = -5; i > -11; i--) {
			items.push({id: i, label: i});
		}
		this.deviceCommonService.ddLists.dead_man_current_limit = items;
	}

	// @todo: valid with IM
	private formatLastSavedUser(device) {

		let lastSavedUser;
		let lastMaintenanceDateUserUpdate;
		if(device.config_info.last_saved_user_id) {

			lastSavedUser = {'type': 'text'};

			if(device.config_info.last_saved_user_id == 0xFFFFFFFF) {

				lastSavedUser['value'] = this.translate.instant('g.system');
			} else {

				lastSavedUser['value'] = device.config_info.last_saved_user_id+' - ';

				if(device.extraInfo.lastSavedUser.is_deleted) {

					lastSavedUser['value'] += this.translate.instant('g.deleted');
				} else {

					lastSavedUser['value'] += device.extraInfo.lastSavedUser.name;

					if(this.usersService.hasAccessFunction('edit_user_admin'))
						lastSavedUser['type'] = 'link';
				}
			}
		}

		this.lastSavedUser = lastSavedUser;

		if (device.config_info.last_pm_user_id) {
			lastMaintenanceDateUserUpdate = {'type': 'text'};
			if (device.config_info.last_pm_user_id == 0xFFFFFFFF) {
				lastMaintenanceDateUserUpdate['value'] = this.translate.instant('g.system');
			} else {
				lastMaintenanceDateUserUpdate['value'] = device.config_info.last_pm_user_id+' - ';

				if(device.extraInfo.lastMaintenanceDateUserUpdate.is_deleted) {

					lastMaintenanceDateUserUpdate['value'] += this.translate.instant('g.deleted');
				} else {

					lastMaintenanceDateUserUpdate['value'] += device.extraInfo.lastMaintenanceDateUserUpdate.name;

					if(this.usersService.hasAccessFunction('edit_user_admin'))
						lastMaintenanceDateUserUpdate['type'] = 'link';
				}
			}
		}
		this.lastMaintenanceDateUserUpdate = lastMaintenanceDateUserUpdate;
	}

	ngOnChanges() {
		if (this.device.config_info) {
			this.commonService.getDeviceTabs(this.device.config_info, this.tab, this.customerID);
			this.setDeviceConfig(this.device.config_info.sct_device_type);
			if(!this.multiDevices)
				this.formatLastSavedUser(lo.cloneDeep(this.device));

			// @todo: hide maintenance for IM 
			this.hasMaintenance = false;
			if(this.device.maintenance) {
				this.hasMaintenance = true;
				this.maintenanceSchedule = lo.cloneDeep(this.device.maintenance);
			}
			this.shiftSchedule = lo.cloneDeep({
				shift_schedule: this.device.config_info.shift_schedule || shiftScheduleOptions.SINGLE_SHIFT,
				inherit_shift_schedule_site_settings: this.device.config_info.inherit_shift_schedule_site_settings
			});

			if(this.device.extra_rules)
				this.extraRules = lo.cloneDeep(this.device.extra_rules);
			this.device = lo.cloneDeep(this.device.config_info);
			this.checkCalibrationCertificate();
			this.updateEventTableColumnsVisibility();
			if(this.usersService.hasAccessFunction('access_rejection_logs'))
				this.getRejectedDeviceConnections();

			this.formatBatterySettingsValues();
			this.device.remoter_server_ip_options = this.setRemoterServerIpOptions();
			this.device.subscription_date = this.device.subscription_date ? moment(this.device.subscription_date * 1000).format('MM/DD/yy') : '--/--/--';
			this.device.meter_sn_changetime = this.device.meter_sn_changetime ? moment(this.device.meter_sn_changetime * 1000).format('MM/DD/yy hh:mm:ss A') : '--/--/--';
			this.device.config_version = this.device.config_version? this.device.config_version : '---';
			this.prepareShipmentQualityAndConnectivityVerficationResult();
			this.device.shipment_quality_passed_time = this.device.shipment_quality_passed_time ? moment(this.device.shipment_quality_passed_time).format('MM/DD/yy') : '--/--/--';
			this.handleLiftTimeCurrentBatterySettings();

			this.device.is_rct_temp = this.translate.instant(this.device.is_rct ? 'devices.is_rct_1' : 'devices.is_rct_0');
			this.deviceService.formatStaticIP(this.device, 'ethernet');
		}
		this.prepareValidationRules();

		// both 0 and 1 are Cellular Only
		if (this.device.metered_flag == 0)
			this.device.metered_flag = 1;

		// both 0 and 1 are Cellular Only
		if (this.device.metered_connection == 0)
			this.device.metered_connection = 1;

		if(Object.keys(this.device).length > 0) {
			this.zoneId = this.device.zone_id;
			if(!this.zoneId)
				this.zoneId = this.currentSite['zone_id'];

			if (this.permissionExists()) {
				this.permissionsCheckup();
				this.initVariables();
				this.resetForms();

				if(!this.multiDevices) {
					if(this.usersService.hasAccessPermission(this.enterprisePermissions, 'noc') && this.usersService.hasAccessFunction('show_warnings')) {
						this.showWarnings();
					} else {
						this.showNoPasswordWarn();
					}
				}
				this.forceDefaultValues();
				this.prepareForms();
			}

			if(this.tab == 'maintenanceSchedule' && this.deviceConfig.hasMaintenanceSchedule)
				this.prepareMaintenanceScheduleData();

			if (this.tab == 'deviceSettings') {
				this.deviceService.formatRtLogFrequencyField(this.device, this.device.rt_log_frequency, false);
				this.prepareVoltageRelatedFields();
			}
		}
	}

	prepareShipmentQualityAndConnectivityVerficationResult() {
		// shipment_quality_result
		this.shipmentLink = null;
		this.connectivityVerficationLink = null;

		let status = 'not_tested';
		if (this.device.shipment_quality_result && this.device.shipment_quality_result.report_id) {
			if (this.device.shipment_quality_result?.result == this.shipmentResults.passed) {
				status = `passed`;
				if (this.device.shipment_quality_result?.skip_cellular_check)
					status = `passed_without_checking_cellular`;
			}

			if (this.device.shipment_quality_result?.result == this.shipmentResults.failed)
				status = `failed`;

			if (this.device.shipment_quality_result.history_source == 1)
				this.shipmentLink = ['/','management', 'receiving-shipment-history', this.device.shipment_quality_result?.report_id];

			else if (this.device.shipment_quality_result.history_source == 2)
				this.shipmentLink = ['/','management', 'shipment-quality-history', this.device.shipment_quality_result?.report_id];
		}
		this.device.shipment_quality_passed = this.translate.instant(`g.${status}`);

		// connectivity_verfication_result
		status = 'not_tested';
		if (this.device.connectivity_verfication_result && this.device.connectivity_verfication_result.report_id) {
			if (this.device.connectivity_verfication_result?.result == this.shipmentResults.passed)
				status = `passed`;

			if (this.device.connectivity_verfication_result?.result == this.shipmentResults.failed)
				status = `failed`;

			this.connectivityVerficationLink = ['/', 'admin-panel', 'connectivity-verification-log', this.device.connectivity_verfication_result?.report_id];
			if (this.device.connectivity_verfication_result?.is_im_device)
				this.connectivityVerficationLink.push('im');
		}

		this.device.connectivity_verfication_status = this.translate.instant(`g.${status}`);
	}

	handleLiftTimeCurrentBatterySettings() {
		this.device.lift_current_threshold_percentage = Math.round(100 * ((this.device.current_lift_upper_threshold + this.device.current_lift_lower_threshold) * -1) / (2 * this.device.battery_capacity));
		if (this.device.lift_current_threshold_percentage == 0) {
			this.device.lift_current_threshold_percentage = 40;
			this.device.lift_current_threshold_delta_percentage = 5;
		}

		this.device.lift_current_threshold_delta_percentage = Math.round((100 * (this.device.current_lift_upper_threshold * -1) / this.device.battery_capacity) - this.device.lift_current_threshold_percentage);
		if (this.device.lift_current_threshold_delta_percentage == 0)
			this.device.lift_current_threshold_delta_percentage = 5;

		this.device.lift_current_threshold_value = (this.device.lift_current_threshold_percentage * this.device.battery_capacity) / 100;
		this.device.lift_current_threshold_delta_value = (this.device.lift_current_threshold_delta_percentage * this.device.battery_capacity) /100;

		this.device.current_lift_upper_threshold = +(this.device.current_lift_upper_threshold?.toFixed(1) ?? this.device.current_lift_upper_threshold);
		this.device.current_lift_lower_threshold = +(this.device.current_lift_lower_threshold?.toFixed(1) ?? this.device.current_lift_lower_threshold);
	}

	ngAfterViewInit() {
		this.selectWifiNetworksModal?.onClose.subscribe((ok) => {
			if(ok) {
				this.updateWifiNetwork();
			} else {
				this.selectWifiNetworksModal?.hide();
				this.availableWifiNetworksModal?.show();
				this.selectedWifiNetwork = {};
			}
		});

		this.restartDeviceConfirm?.onClose.subscribe((ok) => {
			if (ok)
				this.saveChanges();

			this.restartDeviceConfirm?.hide();
		});

		this.unblockDeviceConnectionConfirm?.onClose.subscribe((ok) => {
			if (ok)
				this.unblockDeviceConnection();

			this.unblockDeviceConnectionConfirm?.hide();
		});

		this.newPanelIdModal?.onClose.subscribe(() => this.cancelAddNewPanelId());

		this.deleteChangeStack?.onClose.subscribe((ok) => {
			if (ok) {
				this.removeChangeStack(this.removedChangesStackInfo, false);
				this.confirmDeleteStack = false;
			} else {
				this.deleteChangeStack?.hide();
				this.confirmDeleteStack = false;
			}
		});
	}

	setRemoterServerIpOptions() {
		let server = 'custom';
		for(let option of this.deviceCommonService.getRemoteServerType(this.device.fw_version, this.isIMDevice, this.device.sct_device_type)) {
			if(option.domain == this.device.remoter_server_ip && option.port == this.device.remoter_server_port) {
				server = option.id;
				break;
			}
		}
		return server;
	}

	forceDefaultValues() {
		if(!this.multiDevices && this.tab == 'info' && !this.device.truck_manufacturing_year) {
			this.device.truck_manufacturing_year = 2010;
			this.forceDirtyFields.push('truck_manufacturing_year');
		}
	}

	permissionExists() {
		return Object.keys(this.enterprisePermissions).length > 0 && Object.keys(this.device).length > 0;
	}

	setTab(tabId="") {
		this.commonService.getDeviceTabs(this.device, tabId, this.customerID);
		if(!this.tabs.includes(tabId))
			tabId = 'info';

		// Store previous tab before changing
		this.prevTab = this.tab;

		if (this.prevTab == 'deviceSettings')
			this.resetVoltageRelatedFields();

		this.tab = tabId;
		const tabName = this.translate.instant(this.deviceCommonService.deviceSettingTabsTranslation[tabId]);
		this.commonUtil.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${tabName}`);
		if(this.permissionExists())
			this.forceDefaultValues();

		this.resetForms();

		if(this.tab == 'maintenanceSchedule' && this.deviceConfig.hasMaintenanceSchedule)
			this.prepareMaintenanceScheduleData();

		if (this.tab == 'deviceSettings') {
			this.deviceService.formatRtLogFrequencyField(this.device, this.device.rt_log_frequency, false);
			this.prepareVoltageRelatedFields();
		}
	}

	getSettingUrl() {
		let deviceId = (this.device && this.device.mac_address ? this.device.mac_address : this.route.snapshot.params.deviceId);
		return ['/', this.customerID, this.siteID, deviceId, 'settings'];
	}

	permissionsCheckup() {
		let cardsVisibility	= {};
		let saveChangesVisibility = {};

		for(let card in this.uiStructure) {

			cardsVisibility[card] = false;
			saveChangesVisibility[card] = false;

			let fields = this.uiStructure[card];

			const checkSaveBtnVisibility = this.cardSavebuttonVisibility(card);
			const saveBtnStatus = checkSaveBtnVisibility.status;

			for(let field of fields) {

				let accessType = this.usersService.checkFieldPermissions(field, this.enterprisePermissions.permission, this.permissionMapperKey);

				if(accessType && ['read', 'write'].includes(accessType)) {
					cardsVisibility[card] = true;
					if(saveBtnStatus == 'all' && accessType == 'write') {
						saveChangesVisibility[card] = true;
						break;
					}
					if (saveBtnStatus == 'part') {
						if(checkSaveBtnVisibility.permissions.includes(field) && accessType == 'write') {
							saveChangesVisibility[card] = true;
							break;
						}
					}
				}
			}
		}

		this.cardsVisibility		= cardsVisibility;
		this.saveChangesVisibility	= saveChangesVisibility;
	}

	initVariables() {
		// a saved device comes back from the server without the page only dropdown value, the form is not rebuilt (ST-2746)
		if (this.deviceConfig?.isCharglink && this.chargerManufacturerNames)
			this.setChargerManufacturerOption();

		this.oldDevice = JSON.parse(JSON.stringify(this.device));
		if(this.maintenanceSchedule)
			this.oldMaintenanceSchedule = JSON.parse(JSON.stringify(this.maintenanceSchedule));
		if(this.shiftSchedule)
			this.oldShiftSchedule = JSON.parse(JSON.stringify(this.shiftSchedule));
		this.deviceService.formatDeviceFields(this.device);
	}

	cardSavebuttonVisibility(card) {
		// return {status: 'all'} : permissions are same as ui structure fields.
		// return {status: 'part', fields:[]} : permissions are part of ui structure fields because not all fields are editable.
		// return {status: 'custom'}: skip the check, needs special handling
		if(card == 'info' && !DeviceFactory.isIMDeviceType(this.device.sct_device_type))
			return { status: 'part', permissions: ['setup_key', 'memory_signature', 'serial_number', "fw_version", "installationDateFMT", "study_start_event_id", "device_id", "truck_id", "truck_sn", "truck_type", "study_name", "hardware_version", "in_test_mode", "application_type"] };
		return {status: 'all'};
	}

	showSaveButton(card) {
		return this.saveChangesVisibility[card];
	}

	resetForms(removeErrors = false) {
		if(!removeErrors) {
			this.device = JSON.parse(JSON.stringify(this.oldDevice));
			if(this.oldMaintenanceSchedule)
				this.maintenanceSchedule = JSON.parse(JSON.stringify(this.oldMaintenanceSchedule));
			if(this.oldShiftSchedule)
				this.shiftSchedule = JSON.parse(JSON.stringify(this.oldShiftSchedule));
			this.deviceService.formatDeviceFields(this.device);
		}

		this.dirtyFields = {};
		this.forceDirtyFields = [];
		this.formatBandsFields();
	}

	onBeforeSubmit(formModels) {
		for (const field of this.deviceService.cellularBandsFields) {
			if(!formModels[field])
				continue;

			let cellularBandsArray = formModels[field].value;
			if (Array.isArray(cellularBandsArray)) {
				let cellularBandsSum = 0;

				cellularBandsArray.map((data: number) => cellularBandsSum += data);
				formModels[field].setValue(cellularBandsSum);
			}
		}
	}

	checkChanges(formModels) {
		let dirtyFields: any	= {};
		let arrayFields	= [];
		let freshDevice	= this.device;
		let oldDevice	= this.oldDevice;
		let autoChangable	= ['enc_code', 'remoter_server_port', 'remoter_server_ip', 'shift_schedule'];

		let toNumber	= [
			'in_test_mode',
			'replacement_part',
			'enable_rt',
			'has_water_level',
			'has_temperature_sensor',
			'has_current_low_range',
			'enable_wifi_sta',
			'enable_multicast',
			'enable_wifi_ap_on_start',
			'enable_serversocket',
			'is_online_enabled',
			'setup_reset_data',
			'setup_done',
			'enable_cellular',
			'disable_xtra',
			'disable_external_rtc',
			'enable_current_mask',
			'inherit_shift_schedule_site_settings'
		];
		const dateFields = ['installation_date', 'setup_time', 'last_pm_date', 'last_update_location_time'];

		if(this.forceDirtyFields.length) {
			let dirtyFields = this.forceDirtyFields;
			for(let field of dirtyFields) {
				if(formModels[field]) {
					formModels[field].markAsDirty();
					this.forceDirtyFields = _.without(this.forceDirtyFields, field);
				}
			}
		}

		let zoneDiff = new Date().getTimezoneOffset();

		for(let model in formModels) {
			if(!formModels[model].dirty && !autoChangable.includes(model))
				continue;

			//Convert from boolean (false or true) into integer (0 or 1)
			if (!this.isIMDevice && toNumber.indexOf(model) > -1 && freshDevice[model] !== undefined)
				freshDevice[model] = +freshDevice[model];

			let originalModelName = model;
			if(['installation_date_fmt', 'setup_time_fmt', 'last_pm_date_fmt', 'last_update_location_time_fmt'].includes(model)) {
				originalModelName = model.slice(0, model.indexOf("_fmt"));
			}

			let oldValue = oldDevice[originalModelName];
			let newValue = freshDevice[model];

			if(dateFields.includes(originalModelName)) {
				newValue = moment(newValue).startOf('day').unix();
				//  local time -> utc
				newValue -= (zoneDiff * 60);
			}

			if(arrayFields.indexOf(model) != -1) {

				if(oldValue && newValue && !this.commonUtil.arrayCompare(oldValue, newValue)) {
					dirtyFields[model] = newValue;
				}
			} else if(this.tab == 'info' && model == 'max_charger_kw' && newValue == '') {
				dirtyFields[model] = null;
			} else if(model.includes('.') && !['enable_wifi_sta'].includes(model)) {

				let tmpModel	= model.split('.');
				let netType		= tmpModel[0];
				let netProp		= tmpModel[1];

				oldValue	= oldDevice[netType][netProp];
				newValue	= freshDevice[netType][netProp];

				if(oldValue != newValue) {

					if(!dirtyFields[netType])
						dirtyFields[netType] = {};

					dirtyFields[netType][netProp] = newValue;
				}
			} else if(oldValue != newValue) {

				dirtyFields[originalModelName] = newValue;
			}

			if(originalModelName === 'truck_manufacturing_year' || originalModelName === 'truck_manufacturing_month') {
				const yearValue = parseInt(freshDevice['truck_manufacturing_year']);
				const currentYear = moment().year();
				const currentMonth = moment().month() + 1;
				const monthValue = parseInt(freshDevice['truck_manufacturing_month']);

				if(yearValue === currentYear && monthValue > currentMonth) {
					this.highlightInvalidField('truck_manufacturing_month');
						return this.notificationMessage.setMessage(
						`Truck manufacturing month cannot be greater than ${currentMonth}`,
						{ clearOnXTimeNavigate: 1 }
					);
				}
			}
		}

		this.applyChargerManufacturerOption(dirtyFields);

		if (!this.handleSaveRtLogFrequencyUnit(dirtyFields))
			return this.notificationMessage.setMessage(this.translate.instant('translate|g.invalid_input'), {clearOnXTimeNavigate: 1});

		if ('over_current_threshold' in dirtyFields) {
			const ctRatio = dirtyFields.ct_ratio || this.device.ct_ratio;
			if (dirtyFields.over_current_threshold > ctRatio) {
				this.highlightInvalidField('over_current_threshold');
				return this.notificationMessage.setMessage(this.translate.instant('translate|g.invalid_input'), {clearOnXTimeNavigate: 1});
			}
		}

		if (this.tab == 'eventTypeSettings' && this.isIMDevice && !this.checkImPowerThresholds(dirtyFields))
			return this.notificationMessage.setMessage(this.translate.instant('translate|g.invalid_input'), {clearOnXTimeNavigate: 1});

		let willRestartDevice = false;
		this.restartDeviceChangedFields = [];
		for (const field of Object.keys(dirtyFields)) {
			if (this.fieldRestartDevice.includes(field) || (this.fieldRestartDeviceOnEnable.includes(field) && this.dirtyFields[field])) {
				willRestartDevice = true;
				this.restartDeviceChangedFields.push(field)
			}
		}

		this.changeRemoterServerIp(dirtyFields)
		this.resetOvervoltageLimitDefault(dirtyFields);
		this.modificationsBeforeSave(dirtyFields);

		this.resetForms(true);

		if(Object.keys(dirtyFields).length > 0) {
			this.dirtyFields = dirtyFields;

			this.applyHallEffectSensorCalibration(dirtyFields);

			if (!this.isIMDevice && willRestartDevice)
				return this.restartDeviceConfirm?.show();

			this.saveChanges();
		}
	}

	/**
	 * Runs the IoTEmeter power threshold rules over the Event Type Settings tab and returns whether it may be saved.
	 * The whole tab is held back, not just the fields the user touched, so a device carrying values from before
	 * these rules existed is corrected before anything else on the tab goes through.
	 * On a single device the form is bound to this.device, so it already holds what the user typed layered over
	 * what was stored and an untouched field still takes part in a comparison. On a multi devices save there is no
	 * single stored row to layer onto, so only the submitted values are checked here and the backend checks each
	 * device against its own row.
	 */
	private checkImPowerThresholds(dirtyFields: any): boolean {
		// The events type the tab will land on once saved, which is what the rules follow.
		const eventLogic = 'event_logic' in dirtyFields ? dirtyFields.event_logic : this.device.event_logic;
		const isStateBased = Number(eventLogic) === this.deviceService.eventLogic.stateBased;
		const submittedValues = this.multiDevices ? dirtyFields : this.device;
		const invalidThresholds = this.deviceService.validateImPowerThresholds(submittedValues, { isStateBased });

		if (this.eventTypeSettingsForm)
			this.eventTypeSettingsForm.invalidFields = this.deviceService.imThresholdMessagesToShow(invalidThresholds, dirtyFields);

		return !Object.keys(invalidThresholds).length;
	}

	private changeRemoterServerIp(dirtyFields: any) {
		if (!('sct_device_type' in dirtyFields))
			return;

		const sctType = dirtyFields.sct_device_type;

		const currentOption = dirtyFields.remoter_server_ip_options ?? this.device.remoter_server_ip_options;

		if (currentOption !== 'production')
			return;

		const options = this.deviceCommonService.getRemoteServerType(
			this.device.fw_version,
			this.isIMDevice,
			sctType
		);

		const production = options.find(o => o.id === 'production');

		if (!production)
			return;

		this.setIfChanged(dirtyFields, 'remoter_server_ip', production.domain);
		this.setIfChanged(dirtyFields, 'remoter_server_port', production.port);
		this.setIfChanged(dirtyFields, 'enc_code', production.encCode);
	}
	

	setIfChanged(dirtyFields: any, field: string, newValue: any) {
		const currentValue = field in dirtyFields ? dirtyFields[field] : this.device[field];

		if (currentValue == newValue) {
			delete dirtyFields[field];
			return;
		}

		dirtyFields[field] = newValue;
	}

	getDefaultOvervoltageLimit(sctDeviceType: number, batteryType: number): number {
		if (sctDeviceType === DeviceFactory.types.iotah) {
			return batteryType === this.deviceService.batteryTypesByName.lithuim_ion
				? LITHIUM_OVERVOLTAGE_LIMIT
				: LEAD_ACID_OVERVOLTAGE_LIMIT;
		}

		return overvoltageLimitDefaults[sctDeviceType] ?? LEAD_ACID_OVERVOLTAGE_LIMIT;
	}

	resetOvervoltageLimitDefault(dirtyFields: any) {
		const sctDeviceTypeChanged = 'sct_device_type' in dirtyFields;
		const batteryTypeChanged = 'battery_type' in dirtyFields;

		if (!sctDeviceTypeChanged && !batteryTypeChanged)
			return;

		const sctDeviceType = sctDeviceTypeChanged ? dirtyFields.sct_device_type : this.device.sct_device_type;

		if (!sctDeviceTypeChanged && sctDeviceType !== DeviceFactory.types.iotah)
			return;

		const batteryType = batteryTypeChanged ? dirtyFields.battery_type : this.device.battery_type;

		dirtyFields.overvoltage_limit = this.getDefaultOvervoltageLimit(sctDeviceType, batteryType);
	}

	private applyHallEffectSensorCalibration(dirtyFields: any) {
		if (!this.deviceConfig?.fields.hasHallEffect)
			return;

		if (!('hall_effect_sensor_type' in dirtyFields))
			return;

		// the 750A single-latch, 750A dual-latch and 250A single-latch sensors are one
		// family, so they share a single set of drift and scale values
		const latchFamilyCalibration = {
			current_drift_adc: '-2.616545374',
			current_scale_adc: '0.513415154',
			current_scale_adc_low_range: '-0.511889286',
			current_drift_adc_low_range: '848.2272073'
		};

		const calibrationByType = {
			[this.deviceService.hallEffectSensorTypes.dualScrew]: {
				current_drift_adc: '-1121.419713',
				current_scale_adc: '0.67484785',
				current_scale_adc_low_range: '0.067572306',
				current_drift_adc_low_range: '-110.56121'
			},
			[this.deviceService.hallEffectSensorTypes.singleLatch]: latchFamilyCalibration,
			[this.deviceService.hallEffectSensorTypes.singleLatch250]: latchFamilyCalibration,
			[this.deviceService.hallEffectSensorTypes.dualLatch750]: latchFamilyCalibration
		};

		const selectedCalibration = calibrationByType[dirtyFields.hall_effect_sensor_type];
		if (!selectedCalibration)
			return;

		Object.assign(dirtyFields, selectedCalibration);
	}

	modificationsBeforeSave(dirtyFields) {
		if (
			(dirtyFields?.voltage_reference === undefined && this.device?.voltage_reference === this.deviceService.lineToLine) ||
			(dirtyFields?.voltage_reference === this.deviceService.lineToLine)
		) {
			if (dirtyFields?.under_voltage_threshold) {
				const underVoltageThreshold = this.commonUtil.calcVoltageReference(dirtyFields.under_voltage_threshold, 'divide');
				dirtyFields['under_voltage_threshold'] = underVoltageThreshold;
			}

			if (dirtyFields?.over_voltage_threshold) {
				const overVoltageThreshold = this.commonUtil.calcVoltageReference(dirtyFields.over_voltage_threshold, 'divide');
				dirtyFields['over_voltage_threshold'] = overVoltageThreshold;
			}
		}

		const enabledWiresFieldPermission = this.usersService.hasAccessPermission(this.enterprisePermissions, 'enabled_wires', 'write', null, this.permissionMapperKey);
		if ('wiring_mode' in dirtyFields && !enabledWiresFieldPermission) {
			const wiringModeSettings = this.deviceCommonService.ddLists.wiringModeSettings[dirtyFields.wiring_mode];
			dirtyFields.enabled_wires = wiringModeSettings.enabledWiresDefault;
		}
	}

	handleSaveRtLogFrequencyUnit(data: {rtLogFrequencyUnit: number, rtLogFrequency: number, rt_log_frequency: number}) {
		if ('rtLogFrequencyUnit' in data || 'rtLogFrequency' in data) {

			if ('rtLogFrequencyUnit' in data && data.rtLogFrequencyUnit == this.device.rtLogFrequencyUnit_fmt)
				delete data.rtLogFrequencyUnit;

			if ('rtLogFrequency' in data && data.rtLogFrequency == this.device.rtLogFrequency_fmt)
				delete data.rtLogFrequency;

			if (!Object.keys(data).length)
				return true;

			data.rtLogFrequencyUnit = 'rtLogFrequencyUnit' in data ? data.rtLogFrequencyUnit : this.device.rt_log_frequency > 128 ? this.deviceService.rt_log_frequency_units.minutes.value : this.deviceService.rt_log_frequency_units.seconds.value;
			data.rtLogFrequency = data.rtLogFrequency || (data.rtLogFrequencyUnit ? this.device.rt_log_frequency : this.device.rt_log_frequency - 128);
			data.rtLogFrequencyUnit = +data.rtLogFrequencyUnit * 128 + +data.rtLogFrequency;
		}

		delete data.rt_log_frequency;
		return true;
	}

	saveChanges() {
		if(this.multiDevices)
			return this.saveDeviceSettings('queue');

		// Fields with no device counterpart are written straight to the DB by the backend whatever stage
		// we send, so there is nothing to queue or wait for - do not ask (ST-2472).
		if(this.isDbOnlyChange())
			return this.saveDeviceSettings('db_only');

		if(this.usersService.hasAccessFunction('allow_device_db_save')) {
			this.saveOptionsModal.show();
		} else {
			this.saveDeviceSettings('queue_and_wait');
		}
	}

	// Mirrors deviceDAO.dbOnlySettingsFields (ST-2472). The backend is the authority for where a field is
	// saved; this copy only decides whether to prompt, so drift costs a needless prompt, never a bad save.
	isDbOnlyChange() {
		const dbOnlyFields = ['charger_voltage'];
		const changedFields = Object.keys(this.dirtyFields || {});

		return changedFields.length > 0 && changedFields.every(field => dbOnlyFields.includes(field));
	}

	checkMaintenanceChanges(formModels) {
		let dirtyFields	= {};
		let arrayFields	= [];
		let freshData	= this.maintenanceSchedule;
		let oldData		= this.oldMaintenanceSchedule;

		let flags = [
			'report_ahr_opt',
			'report_kwhr_opt',
			'report_usage_hours_opt',
			'report_period_opt',
		];

		let enabled = false;
		for(let flag of flags)
			enabled = enabled || this.maintenanceSchedule[flag];
		if(!enabled)
			return this.notificationMessage.setMessage(this.translate.instant('maintenance_schedule.err_min_option_enabled'), {clearOnXTimeNavigate: 1});

		if(this.forceDirtyFields.length) {
			let dirtyFields = this.forceDirtyFields;
			for(let field of dirtyFields) {
				if(formModels[field]) {
					formModels[field].markAsDirty();
					this.forceDirtyFields = _.without(this.forceDirtyFields, field);
				}
			}
		}

		for(let model in formModels) {
			if(!formModels[model].dirty)
				continue;

			//Convert from boolean (false or true) into integer (0 or 1)
			if(flags.indexOf(model) > -1 && freshData[model] !== undefined)
				freshData[model] = +freshData[model];

			let originalModelName = model;

			let oldValue = oldData[originalModelName];
			let newValue = freshData[model];

			if(arrayFields.indexOf(model) != -1) {
				if(oldValue && newValue && !this.commonUtil.arrayCompare(oldValue, newValue)) {
					dirtyFields[model] = newValue;
				}
			} else if(oldValue != newValue) {
				dirtyFields[originalModelName] = newValue;
			}
		}
		this.resetForms(true);

		for(let flag of flags) {
			let textField = flag.replace('_opt', '');
			if(!this.maintenanceSchedule[flag])
				delete dirtyFields[textField];
		}

		if(Object.keys(dirtyFields).length > 0) {
			if(this.multiDevices) {
				let deviceIds = this.deviceIds.split(',');
				this.deviceService.saveMultiMaintenanceSchedule(deviceIds, dirtyFields).subscribe((response: any) => {
					this.handleMaintenanceSaveResponse(response);
				});
			} else {
				this.deviceService.saveMaintenanceSchedule(this.device.mac_address, dirtyFields).subscribe((response: any) => {
					this.handleMaintenanceSaveResponse(response);
				});
			}
		}
	}

	checkShiftScheduleChanges(formModels) {
		let dirtyFields: any = {};
		let freshData = this.shiftSchedule;
		let oldData = this.oldShiftSchedule;

		const booleanToIntFields = ['inherit_shift_schedule_site_settings'];

		if (this.forceDirtyFields.length) {
			for (let field of [...this.forceDirtyFields]) {
				if (formModels[field]) {
					formModels[field].markAsDirty();
					this.forceDirtyFields = _.without(this.forceDirtyFields, field);
				}
			}
		}

		for (let model in formModels) {
			if (!formModels[model].dirty)
				continue;

			let oldValue = oldData[model];
			let newValue = freshData[model];

			if (booleanToIntFields.includes(model) && typeof newValue === 'boolean')
				newValue = +newValue;

			if (oldValue != newValue)
				dirtyFields[model] = newValue;
		}

		this.resetForms(true);

		if (Object.keys(dirtyFields).length > 0) {
			this.dirtyFields = dirtyFields;
			this.deviceService.saveDeviceSettings(this.device.mac_address, dirtyFields, 'direct', {}, 0).subscribe((response: any) => {
				this.handleSaveResponse(response, 'direct', dirtyFields, this.device.mac_address);
			});
		}
	}

	showWarnings() {
		if(!['', 'info'].includes(this.tab))
			return;

		// IM devices bypass the per-warning permission mapper (most of their warning keys have no
		// entry in fieldPermissionMapper-01.json) and are computed live from the device's own
		// fields, the same way the IoTEmeter app itself does on this page — not from device_warnings
		// rows on the server, which don't exist for IM devices.
		const isImDevice = DeviceFactory.isIMDeviceType(this.device.sct_device_type);
		// same check showNoPasswordWarn() uses for the ST "no password" notice
		const includePassword = this.usersService.hasAccessPermission(this.enterprisePermissions, 'device_password');
		const warnings$ = isImDevice
			? of(this.deviceService.getIMDeviceWarnings(this.device, { includePassword }))
			: this.deviceService.getCurrentWarningsList(this.device.mac_address);

		warnings$.subscribe((deviceWarnings: any) => {

			let userSessionCookie = this.cookieService.get('userSession');
			let deviceWarningsCookie = this.cookieService.get('warnings_modal_'+this.device.mac_address);

			if (userSessionCookie != deviceWarningsCookie) {
				const permission = this.enterprisePermissions.permission;
				this.deviceWarnings = isImDevice
					? (deviceWarnings || [])
					: this.deviceService.filterWarningsByPermission(deviceWarnings || [], permission, {canIgnorePermission: true});

				if (this.deviceWarnings.length) {
					setTimeout(() => {
						this.warningsModal.show();
						this.cookieService.set('warnings_modal_'+this.device.mac_address, userSessionCookie);
					}, 0);
				}
			}
		});

	}

	showNoPasswordWarn() {

		if(!['', 'info'].includes(this.tab))
			return;

		let noPassword = !this.device.device_password;
		let hasAccess = this.usersService.hasAccessPermission(this.enterprisePermissions, 'device_password');
		let userSessionCookie = this.cookieService.get('userSession');
		let devicePassCookie = this.cookieService.get('pass_modal_'+this.device.mac_address);

		if(hasAccess && noPassword && userSessionCookie != devicePassCookie) {
			setTimeout(() => {
				this.deviceWithoutPasswordModal.show();
				this.cookieService.set('pass_modal_'+this.device.mac_address, userSessionCookie);
			}, 0);
		}
	}

	saveDeviceSettings(stage) {

		let originalStage = stage;
		if(this.usersService.hasAccessFunction('allow_device_db_save') && this.saveOptionsModal.render)
			this.saveOptionsModal.hide();

		if(stage == 'cancel')
			return;

		let dirtyFields	= this.dirtyFields;

		if(this.multiDevices) {
			let deviceIds = this.deviceIds.split(',');
			this.deviceService.saveMultiDevicesSettings(deviceIds, dirtyFields).subscribe((response: any) => {
				this.handleSaveResponse(response, originalStage, dirtyFields);
			});
		} else {
			let wait		= 0;
			let mac_address	= this.device.mac_address;

			if(stage == 'queue_and_wait'){
				wait = this.deviceService.waitTimeout;
				stage = 'queue';
			}

			// db_only keeps the UI meaning (nothing was queued, the value is already applied) while the
			// request goes out as an ordinary queue save. direct is not an option here: it is gated behind
			// the allow_device_db_save management function that most users do not have.
			if(stage == 'db_only')
				stage = 'queue';

			let options: any = {};
			if(stage == 'queue') {
				options.get_changes_stack = true;
			}

			this.deviceService.saveDeviceSettings(mac_address, dirtyFields, stage, options, wait).subscribe((response: any) => {
				this.handleSaveResponse(response, originalStage, dirtyFields, mac_address);
			});
		}
	}

	setDeviceConfig(sctDeviceType: number) {
		this.deviceConfig = DeviceFactory.createDevice(sctDeviceType).config;
		this.permissionMapperKey = this.deviceConfig.permissionMapperKey;
	}

	handleSaveResponse(response, stage, dirtyFields, deviceId?) {
		const apiStatus = response.api_status;

		if (response.response_status == this.loader.resStatus.api_timeout || apiStatus == this.deviceService.deviceCommandsResponse) { // if the api timed-out OR if wait sent and the device is disconnected.
			this.notificationMessage.setMessage('translate|settings.queue_and_wait_timeout_msg', {clearOnXTimeNavigate: 1, type: 'warning'});
			response = response.response;
		} else {
			if(response.invalid_fields)
				return this.notificationMessage.setMessage(this.translate.instant('g.invalid_input'), {clearOnXTimeNavigate: 1});
			if(stage == 'queue')
				this.notificationMessage.setMessage('translate|devices_settings.changes_queued', {clearOnXTimeNavigate: 1, type: 'warning'});
			else {
				this.shouldRefressPage(dirtyFields);
				this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
			}
		}
		if(response.changes_stack)
			this.changesStack = this.deviceService.formatChangesStack(response.changes_stack, this.zoneId, this.device);

		this.device = response.config_info;

		// ST-2591: an applied device type change must switch the tabs and fields without a page refresh.
		// A queued change still returns the old type here, so nothing switches until the device accepts it.
		if (!this.multiDevices && this.device.sct_device_type != this.deviceConfig.sct_device_type) {
			this.setDeviceConfig(this.device.sct_device_type);
			this.commonService.getDeviceTabs(this.device, this.tab, this.customerID);
		}

		// both 0 and 1 are Cellular Only
		if (this.device.metered_flag == 0)
			this.device.metered_flag = 1;

		if (this.device.metered_connection == 0)
			this.device.metered_connection = 1;

		this.maintenanceSchedule = response.maintenance;
		this.shiftSchedule = {
			shift_schedule: this.device.shift_schedule,
			inherit_shift_schedule_site_settings: this.device.inherit_shift_schedule_site_settings
		}
		this.device.subscription_date = this.device.subscription_date ? moment(this.device.subscription_date * 1000).format('MM/DD/yy') : '--/--/--';
		this.device.config_version = this.device.config_version? this.device.config_version : '---';

		this.updateEventTableColumnsVisibility();
		this.initVariables();

		// update dropdown list
		this.device.remoter_server_ip_options = this.setRemoterServerIpOptions();
		this.formatBandsFields();
		this.deviceService.formatRtLogFrequencyField(this.device, this.device.rt_log_frequency, false);

		//update maintenance form (validation)
		this.prepareMaintenanceScheduleForm();
		this.handleLiftTimeCurrentBatterySettings();

		this.actualVoltageValue = this.lastVoltageRefOption;

		if (this.device?.voltage_reference === this.deviceService.lineToLine)
			this.updateDeviceThresholdInfo('multi');

		this.handleVoltageReferenceField(this.device.wiring_mode);
		this.updateThresholdField();

		this.formatBatterySettingsValues();

		this.deviceService.formatStaticIP(this.device, 'ethernet');

		this.device.shipment_quality_passed = this.translate.instant(`g.${this.device.shipment_quality_passed ? 'yes' : 'no'}`);

		this.device.connectivity_verfication_status = this.translate.instant(`g.${this.device.connectivity_verfication_status ? 'yes' : 'no'}`);

		const changesApplied = stage == 'direct' || stage == 'db_only';

		// update select device options
		if (changesApplied || (stage == 'queue_and_wait' && apiStatus != this.deviceService.deviceCommandsResponse)) {
			this.updateDeviceAttributes.emit({deviceId, updatedDeviceData: dirtyFields});
			this.onDeviceDataChange.emit(this.device); // to update device config data
		}
	}
	
	formatBandsFields() {
		for (let bandField of this.deviceService.cellularBandsFields) {
			let bandFieldValues = this.device[bandField];

			if (!bandFieldValues || Array.isArray(bandFieldValues))
				continue;

			let cellularBandArray = [];
			let changeStackBandArray = [];

			const cellularBands = lo.uniqBy([...this.deviceCommonService.ddLists.lte_bands, ...this.deviceCommonService.ddLists.nbiot_bands], 'value');

			for (let field of cellularBands) {
				if ((bandFieldValues & field.value) != 0)
					cellularBandArray.push(field.value);

				if (bandField in this.changesStack) {
					if ((this.changesStack[bandField][this.changesStack[bandField].length - 1][0] & field.value) != 0) // last change stack
						changeStackBandArray.push(field.text + '  ');
				}
			}

			this.device[bandField] = cellularBandArray;

			if (bandField in this.changesStack && !Array.isArray(this.changesStack[bandField][0][0]))
				this.changesStack[bandField][this.changesStack[bandField].length - 1][0] = changeStackBandArray; // TODO: This will handle last change. edit it after adding merge stack changes ticket.
		}
	}

	handleMaintenanceSaveResponse(response) {
		if(response.invalid_fields)
			return this.notificationMessage.setMessage(this.translate.instant('g.invalid_input'), {clearOnXTimeNavigate: 1});
		this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
		this.maintenanceSchedule = response.maintenance;
		this.initVariables();
	}

	shouldRefressPage(dirtyFields) {
		const fieldsToCheck = ['installation_date'];

		for (const field of fieldsToCheck) {
			if (field in dirtyFields) {
				window.location.reload();
				return; // Exit the function after the page refreshes
			}
		}
	}

	prepareForms() {
		if(!this.deviceCommonService.ddLists.dead_man_current_limit.length)
			this.prepareDeadManCurrentLimitList();
		if(!this.zones.length)
			this.zones = this.commonData.TimeZonesMenu;

		this.prepareInfoForm();
		this.prepareDeviceSettingsForm();
		this.prepareBatterySettingsForm();
		this.prepareCalForm();
		this.prepareNetworkingSettingsForm();
		this.prepareNetworkingForm();
		this.prepareBilledKWHrsSettingsForm();
		this.prepareMaintenanceScheduleForm();

		if (this.isIMDevice)
			this.prepareEventTypeSettingsForm();

		this.prepareShiftScheduleForm();
		this.filterFields();

		// @todo: check multiDevices with IM
		if(this.multiDevices) {
			this.infoFormFields = this.infoFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.deviceInfo.includes(field.name);
			});
			this.deviceSettingsFormFields = this.deviceSettingsFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.deviceSettings.includes(field.name);
			});
			this.batterySettingsFormFields = this.batterySettingsFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.batterySettings.includes(field.name);
			});
			this.calFormFields = this.calFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.cal.includes(field.name);
			});
			this.networkingSettingsFormFields = this.networkingSettingsFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.networkingSettings.includes(field.name);
			});
			this.networkingFormFields = this.networkingFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.networking.includes(Array.isArray(field.name)? field.name.join('.'): field.name);
			});
			this.billedKWHrsSettingsFormFields = this.billedKWHrsSettingsFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.billedKWHrsSettings.includes(field.name);
			});
			this.maintenanceScheduleFormFields = this.maintenanceScheduleFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.maintenanceSchedule.includes(field.name);
			});
			this.shiftScheduleFormFields = this.shiftScheduleFormFields.filter((field) => {
				return this.deviceService.multiSettingsFields.shiftSchedule.includes(field.name);
			});
		}
	}

	// ST-2490: NOC or Debug Data can see the cell-tower-based Estimated Location section.
	// Extracted so it is directly unit-testable -- prepareInfoForm() itself pulls in a
	// large, unrelated dependency graph (deviceConfig.requiredFields, fillStudiesField(),
	// truck manufacturer/type lookups, ...) that has nothing to do with this check.
	hasEstimatedLocationAccess(): boolean {
		const hasNoc = this.usersService.hasAccessPermission(this.enterprisePermissions, 'noc');
		const hasDebugData = this.usersService.hasAccessPermission(this.enterprisePermissions, 'debug_data');
		return hasNoc || hasDebugData;
	}

	// ST-2532: the cell-tower fix is a real location only when both coordinates are present and
	// non-zero -- a device with no fix reports 0,0, which reads as N/A the same way null does.
	hasValidEstimatedLocation(): boolean {
		return !!this.device.estimated_latitude && !!this.device.estimated_longitude;
	}

	prepareInfoForm() {
		if(DeviceFactory.isIMDeviceType(this.device.sct_device_type))
			return this.prepareIMInfoForm();

		this.infoFormFields = [
			{
				name: 'memory_signature',
				label: 'devices.memory_signature',
				permission: 'memory_signature',
				type: 'label'
			},
		];

		if(this.lastSavedUser) {
			this.infoFormFields.push(
				{
					name: 'lastSavedUser',
					label: 'devices.last_saved_user_id',
					permission: 'memory_signature',
					type: (this.lastSavedUser.type == 'link' ? 'link' : 'label'),
					value: this.lastSavedUser.value,
					link: (this.lastSavedUser.type == 'link' ? ['/user', 'edit', this.device.last_saved_user_id] : null)
				}
			);
		}
		if(this.device.last_change_time) {
			this.infoFormFields.push(
				{
					name: 'last_change_time',
					label: 'devices.last_change_time',
					permission: 'memory_signature',
					type: 'dateLabel'
				}
			);
		}
		this.infoFormFields = this.infoFormFields.concat([
			{
				name: 'mac_address',
				label: 'g.mac_address',
				permission: 'read',
				type: 'label',
				tooltip: this.deviceService.getTranslationKey('mac_address', this.device)
			},
			{
				name: 'serial_number',
				label: 'g.serial_number',
				permission: 'serial_number',
				type: 'label',
				tooltip: this.deviceService.getTranslationKey('serial_number', this.device)
			},
			{
				name: 'cm_po_number',
				label: 'shipment.cm_po_number',
				permission: 'noc',
				type: 'label',
				tooltip: 'cm_po_number'
			},
		]);
		if(this.device.fw_version) {
			const isAdmin =  this.usersService.getCurrentUser().is_admin;
			this.infoFormFields.push(
				{
					name: 'fw_version',
					label: 'devices.fw_version',
					permission: 'fw_version',
					type: 'label',
					tooltip: this.deviceService.getTranslationKey('fw_version', this.device),
					value: this.commonUtil.toFixedWithoutRounding(this.device.fw_version, isAdmin ? 4 : 2) + (this.device.firmware_version_to_push && !this.device.testing_fw ? ', ' + this.translate.instant('settings.fw_version_to_push')+':'+ this.commonUtil.toFixedWithoutRounding(this.device.firmware_version_to_push, isAdmin? 4 : 2) : '')
				}
			);
		}

		if(this.usersService.getCurrentUser().isSCT && this.device.fw_version >= this.minFWVersionForMemoryMapFields) {
			this.infoFormFields.push(
				{
					name: 'memory_map_version',
					label: 'devices.memory_map_version',
					permission: 'noc',
					type: 'label',
					value: this.device.memory_map_version == 2 ? 'V2' : 'V1'
				},
				{
					name: 'psram',
					label: 'devices.psram',
					permission: 'noc',
					type: 'label',
					value: this.translate.instant(this.device.psram ? 'g.yes' : 'g.no')
				}
			);
		}

		const truckManufacturersItem: any = {
			name: 'truck_manufacturer',
			label: this.deviceService.getTranslationKey('devices.truck_manufacturer', this.device),
			permission: 'truck_manufacturer',
			type: 'autocomplete',
			validation: this.validationRules.truck_manufacturer,
			tooltip: this.deviceService.getTranslationKey('truck_manufacturer', this.device),
			required: this.deviceConfig.requiredFields.truckManufacturer
		};

		const truckTypeItem: any = {
			name: 'truck_type',
			label: this.deviceService.getTranslationKey('devices.truck_type', this.device),
			permission: 'truck_type',
			type: 'dropdown-grouped',
			bindLabel: 'name',
			bindValue: 'name',
			groupBy: 'category',
			addTag: true, 
			validation: this.validationRules.truck_type,
			tooltip: this.deviceService.getTranslationKey('truck_type', this.device),
			required: this.deviceConfig.requiredFields.truckType
		};

		if(this.deviceConfig.requiredFields.truckManufacturer)
			truckManufacturersItem.items = truckManufacturers;

		if(this.deviceConfig.requiredFields.truckType)
			truckTypeItem.items = truckTypes;

		const geofenceStatus = this.deviceService.getGeofenceStatusDisplay(this.device);

		this.infoFormFields = this.infoFormFields.concat([
			{
				name: 'shipment_quality_passed',
				label: 'devices.shipment_quality_checked',
				permission: 'shipment_quality_passed',
				type: this.shipmentLink ? 'link' : 'label',
				link: this.shipmentLink
			},
			{
				name: 'shipment_quality_passed_time',
				label: 'devices.shipment_quality_passed_time',
				permission: 'shipment_quality_passed_time',
				type: 'label',
			},
			{
				name: 'connectivity_verfication_status',
				label: 'devices.connectivity_verfication_status',
				permission: 'noc',
				type: this.connectivityVerficationLink ? 'link' : 'label',
				disabled: true,
				link: this.connectivityVerficationLink
			},
			{
				name: 'geo_fence_status',
				label: 'devices.geo_fence_status',
				permission: 'geo_fence_status',
				type: 'badge',
				value: geofenceStatus.text,
				badgeClass: geofenceStatus.badgeClass
			},
			{
				name: 'subscription_date',
				label: 'devices.subscription_date',
				permission: 'subscription_date',
				type: 'label'
			},
			{
				name: 'device_id',
				label: 'devices.device_id',
				permission: 'device_id',
				type: 'label',
				validation: this.validationRules.device_id
			},
			...this.fillStudiesField(),
			{
				name: 'installation_date_fmt',
				label: 'devices.installation_date',
				permission: 'installation_date',
				type: 'date',
				minDate: new Date(moment().subtract(5, 'years').unix()*1000),
				maxDate: new Date(moment().unix()*1000),
				validation: this.validationRules.installation_date,
				required: true,
				tooltip: this.deviceService.getTranslationKey('installation_date', this.device),
			},
			{
				name: 'truck_id',
				label: this.deviceService.getTranslationKey('devices.truck_id', this.device),
				permission: 'truck_id',
				type: 'text',
				validation: this.validationRules.truck_id,
				tooltip: this.deviceService.getTranslationKey('truck_id', this.device),
			},
			{
				name: 'truck_sn',
				label: this.deviceService.getTranslationKey('devices.truck_sn', this.device),
				permission: 'truck_sn',
				type: 'text',
				validation: this.validationRules.truck_sn,
				tooltip: this.deviceService.getTranslationKey('truck_sn', this.device),
				required: true
			},
			...this.getTruckManufacturerFields(truckManufacturersItem)
		]);
		if (this.deviceConfig.requiredFields.truckManufacturingMonth) {
			this.infoFormFields.push({
				name: 'truck_manufacturing_month',
				label: this.deviceService.getTranslationKey('devices.truck_manufacturing_month', this.device),
				permission: 'truck_manufacturing_year',
				type: 'text',
				validation: this.validationRules.truck_manufacturing_month,
				required: true,
				tooltip: this.deviceService.getTranslationKey('truck_manufacturing_month', this.device),
			});
		}
		if (this.deviceConfig.requiredFields.truckManufacturingYear) {
			this.infoFormFields.push({
				name: 'truck_manufacturing_year',
				label: this.deviceService.getTranslationKey('devices.truck_manufacturing_year', this.device),
				permission: 'truck_manufacturing_year',
				type: 'text',
				validation: this.validationRules.truck_manufacturing_year,
				required: this.deviceConfig.requiredFields.truckManufacturingYear,
				tooltip: this.deviceService.getTranslationKey('truck_manufacturing_year', this.device),
			})
		}

		this.infoFormFields.push(truckTypeItem);

		if(this.deviceConfig.fields.chargerVoltage) {
			this.infoFormFields.push({
				name: 'charger_voltage',
				label: 'devices.charger_voltage',
				permission: 'charger_voltage',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.charger_voltage,
				bindLabel: 'text',
				bindValue: 'value',
				validation: this.validationRules.charger_voltage
			})
		}

		if(this.deviceConfig.fields.hasMaxChargerKw) {
			this.infoFormFields.push({
				name: 'max_charger_kw',
				label: 'devices.max_charger_kw',
				permission: 'max_charger_kw',
				type: 'number'
			});
		}

		this.infoFormFields.push(
			{
				name: 'hw_version',
				label: 'devices.hw_version',
				permission: 'hw_version',
				type: 'text',
				validation: this.validationRules.hw_version,
				required: true,
				tooltip: this.deviceService.getTranslationKey('hw_version', this.device),
			},
			{
				name: 'in_test_mode',
				label: 'devices.in_test_mode',
				permission: 'in_test_mode',
				type: 'boolean',
				validation: this.validationRules.in_test_mode,

			},
			{
				name: 'setup_requested_site',
				label: 'devices.setup_requested_site',
				permission: 'memory_signature',
				type: 'text',
				validation: this.validationRules.setup_requested_site
			},
			{
				name: 'setup_requested_customer',
				label: 'devices.setup_requested_customer',
				permission: 'memory_signature',
				type: 'text',
				validation: this.validationRules.setup_requested_customer
			},
			{
				name: 'setup_requested_address',
				label: 'devices.setup_requested_address',
				permission: 'memory_signature',
				type: 'text',
				validation: this.validationRules.setup_requested_address
			},
			{
				name: 'setup_replace_mac',
				label: 'devices.setup_replace_mac',
				permission: 'memory_signature',
				type: 'text',
				validation: this.validationRules.setup_replace_mac
			},
			{
				name: 'setup_user_id',
				label: 'devices.setup_user_id',
				permission: 'memory_signature',
				type: 'text',
				validation: this.validationRules.setup_user_id,
				required: true
			},
			{
				name: 'setup_time_fmt',
				label: 'devices.setup_time',
				permission: 'memory_signature',
				type: 'date',
				validation: this.validationRules.setup_time
			},
			{
				name: 'setup_done',
				label: 'devices.setup_done',
				permission: 'setup_done',
				type: 'boolean',
				validation: this.validationRules.setup_done
			},
			{
				name: 'setup_reset_data',
				label: 'devices.setup_reset_data',
				permission: 'memory_signature',
				type: 'boolean',
				validation: this.validationRules.setup_reset_data
			},
			{
				name: 'last_pm_date',
				label: 'devices.last_pm_date',
				permission: 'device_config_attribute',
				type: 'dateLabel',
				format: 'MM/dd/yyyy'
			}
		);

		if (this.lastMaintenanceDateUserUpdate) {
			this.infoFormFields.push(
				{
					name: 'lastMaintenanceUser',
					label: 'devices.last_pm_user_id',
					permission: 'device_config_attribute',
					type: (this.lastMaintenanceDateUserUpdate.type == 'link' ? 'link' : 'label'),
					value: this.lastMaintenanceDateUserUpdate.value,
					link: (this.lastMaintenanceDateUserUpdate.type == 'link' ? ['/user', 'edit', this.device.last_pm_user_id] : null)
				},
			);
		}

		this.infoFormFields.push(
			{
				name: 'latitude',
				label: 'devices.latitude',
				permission: 'latitude',
				type: 'text',
				validation: this.validationRules.latitude
			},
			{
				name: 'longitude',
				label: 'devices.longitude',
				permission: 'longitude',
				type: 'text',
				validation: this.validationRules.longitude
			},
			{
				label: 'devices.location',
				permission: 'noc',
				type: 'subSectionTitle'
			},
			{
			 	name: 'last_latitude',
				label: 'devices.last_latitude',
				permission: 'noc',
				type: 'label'
			},
			{
			 	name: 'last_longitude',
				label: 'devices.last_longitude',
				permission: 'noc',
				type: 'label'
			},
			{
			 	name: 'last_update_location_time_fmt',
				label: 'devices.last_update_location_time',
				permission: 'noc',
				type: 'label',
				timeSourceTooltip: this.commonService.getTimeSourceTooltip(TimeSource.PcTime),
			}
		);

		// ST-2490: Estimated Location -- cell-tower-based, shown separately from the GNSS
		// Location section above. Visible to NOC or Debug Data (sct-form's per-field
		// `permission` string can't express an OR, so the check happens here instead).
		if(this.hasEstimatedLocationAccess()) {
			this.infoFormFields.push(
				{
					label: 'devices.estimated_location',
					permission: 'read',
					type: 'subSectionTitle'
				},
				{
					name: 'estimated_latitude',
					label: 'devices.estimated_latitude',
					permission: 'read',
					type: 'label',
					value: this.hasValidEstimatedLocation() ? this.device.estimated_latitude : this.translate.instant('g.n/a')
				},
				{
					name: 'estimated_longitude',
					label: 'devices.estimated_longitude',
					permission: 'read',
					type: 'label',
					value: this.hasValidEstimatedLocation() ? this.device.estimated_longitude : this.translate.instant('g.n/a')
				}
			);
		}
	}

	prepareIMInfoForm() {
		this.infoFormFields = [
			{
				name: 'setup_key',
				label: 'devices.setup_key',
				permission: 'setup_key',
				type: 'label'
			},
			{
				name: 'memory_signature',
				label: 'devices.memory_signature',
				permission: 'memory_signature',
				type: 'label'
			},
		];

		if(this.lastSavedUser) {
			this.infoFormFields.push(
				{
					name: 'lastSavedUser',
					label: 'devices.last_saved_user_id',
					permission: 'memory_signature',
					type: (this.lastSavedUser.type == 'link' ? 'link' : 'label'),
					value: this.lastSavedUser.value,
					link: (this.lastSavedUser.type == 'link' ? ['/user', 'edit', this.device.last_saved_user_id] : null)
				}
			);
		}
		if(this.device.last_change_time) {
			this.infoFormFields.push(
				{
					name: 'last_change_time',
					label: 'devices.last_change_time',
					permission: 'memory_signature',
					type: 'dateLabel'
				}
			);
		}

		this.infoFormFields.push(
			{
				name: 'mac_address',
				label: 'g.mac_address',
				permission: 'mac_address',
				type: 'label',
			},
			{
				name: 'serial_number',
				label: 'g.serial_number',
				permission: 'serial_number',
				type: 'label',
			},
			{
				name: 'cm_po_number',
				label: 'shipment.cm_po_number',
				permission: 'cm_po_number',
				type: 'label',
			},
		);

		if(this.isFWSupportField('meter_sn'))
			this.infoFormFields.push(
				{
					name: 'meter_sn',
					label: this.deviceService.translate('devices.meter_sn', this.device),
					permission: 'meter_sn',
					type: 'label',
				},
				{
					name: 'meter_sn_changetime',
					label: this.deviceService.translate('devices.meter_sn_changetime', this.device),
					permission: 'meter_sn_changetime',
					type: 'label',
				}
			);

		this.infoFormFields.push(
			{
				name: 'subscription_date',
				label: 'devices.subscription_date',
				permission: 'subscription_date',
				type: 'label',
			}
		);

		if(this.device.fw_version) {
			const isAdmin =  this.usersService.getCurrentUser().is_admin;
			this.infoFormFields.push(
				{
					name: 'fw_version',
					label: 'devices.fw_version',
					permission: 'fw_version',
					type: 'label',
					value: this.commonUtil.toFixedWithoutRounding(this.device.fw_version, isAdmin ? 4 : 2) + (this.device.firmware_version_to_push && !this.device.testing_fw ? ', ' + this.translate.instant('settings.fw_version_to_push')+':'+ this.commonUtil.toFixedWithoutRounding(this.device.firmware_version_to_push, isAdmin? 4 : 2) : '')
				}
			);
		}

		this.infoFormFields.push(
			{
				name: 'shipment_quality_passed',
				label: 'devices.shipment_quality_checked',
				permission: 'noc',
				type: this.shipmentLink ? 'link' : 'label',
				link: this.shipmentLink
			},
			{
				name: 'shipment_quality_passed_time',
				label: 'devices.shipment_quality_passed_time',
				permission: 'noc',
				type: 'label',
			},
			{
				name: 'connectivity_verfication_status',
				label: 'devices.connectivity_verfication_status',
				permission: 'noc',
				type: this.connectivityVerficationLink ? 'link' : 'label',
				disabled: true,
				link: this.connectivityVerficationLink
			},
		);

		this.infoFormFields.push(
			{
				name: 'installation_date_fmt',
				label: 'devices.installation_date',
				permission: 'installation_date',
				type: 'date',
				minDate: new Date(moment().subtract(5, 'years').unix()*1000),
				maxDate: new Date(moment().unix()*1000),
				validation: this.validationRules.installation_date,
				required: true,
			},
			{
				name: 'hw_version',
				label: 'devices.hw_version',
				permission: 'hw_version',
				type: 'text',
				validation: this.validationRules.hw_version,
				required: true,
			},
			{
				name: 'power_view_id',
				label: this.deviceService.translate('devices.power_view_id', this.device),
				permission: 'power_view_id',
				type: 'text',
				validation: this.validationRules.power_view_id,
				required: true,
			},
			{
				name: 'power_view_sn',
				label: this.deviceService.translate('devices.panel_id', this.device),
				permission: 'power_view_sn',
				type: 'dropdown',
				items: this.panelIdOptions,
				bindLabel: 'label',
				bindValue: 'value',
				searchable: true,
				validation: this.validationRules.power_view_sn,
			},
			{
				name: 'load_type',
				label: this.deviceService.translate('devices.load_type', this.device),
				permission: 'load_type',
				type: 'text',
				validation: this.validationRules.load_type,
				required: false,
			},
		{
				name: 'in_test_mode',
				label: 'devices.in_test_mode',
				permission: 'in_test_mode',
				type: 'boolean',
				validation: this.validationRules.in_test_mode,
				asBoolean: true,
			},
			{
				name: 'setup_done',
				label: 'devices.setup_done',
				permission: 'setup_done',
				type: 'boolean',
				validation: this.validationRules.setup_done,
				asBoolean: true,
			},
			{
				name: 'setup_reset_data',
				label: 'devices.setup_reset_data',
				permission: 'setup_reset_data',
				type: 'boolean',
				validation: this.validationRules.setup_reset_data,
				asBoolean: true,
			}
		);

		if(this.isFWSupportField('sct_pre_configured')) {
			this.infoFormFields.push(
				{
					name: 'sct_pre_configured',
					label: 'devices.sct_pre_configured',
					permission: 'sct_pre_configured',
					type: 'boolean',
					validation: this.validationRules.sct_pre_configured,
					asBoolean: true,
				},
			);
		}

		this.infoFormFields.push(
			{
				name: 'setup_user_id',
				label: 'devices.setup_user_id',
				permission: 'setup_user_id',
				type: 'text',
				validation: this.validationRules.setup_user_id,
				required: true
			},
			{
				name: 'setup_time_fmt',
				label: 'devices.setup_time',
				permission: 'setup_time',
				type: 'date',
				validation: this.validationRules.setup_time
			},
			{
				name: 'setup_requested_site',
				label: 'devices.setup_requested_site',
				permission: 'setup_requested_site',
				type: 'text',
				validation: this.validationRules.setup_requested_site
			},
			{
				name: 'setup_requested_customer',
				label: 'devices.setup_requested_customer',
				permission: 'setup_requested_customer',
				type: 'text',
				validation: this.validationRules.setup_requested_customer
			},
			{
				name: 'setup_requested_address',
				label: 'devices.setup_requested_address',
				permission: 'setup_requested_address',
				type: 'text',
				validation: this.validationRules.setup_requested_address
			},
			{
				name: 'setup_replace_mac',
				label: 'devices.setup_replace_mac',
				permission: 'setup_replace_mac',
				type: 'text',
				validation: this.validationRules.setup_replace_mac
			},
			{
				name: 'latitude',
				label: 'devices.latitude',
				permission: 'latitude',
				type: 'text',
				validation: this.validationRules.latitude
			},
			{
				name: 'longitude',
				label: 'devices.longitude',
				permission: 'longitude',
				type: 'text',
				validation: this.validationRules.longitude
			},
			{
				name: 'is_rct_temp',
				label: 'devices.is_rct',
				permission: 'is_rct',
				type: 'label',
			},
			{
				label: 'devices.location',
				permission: 'noc',
				type: 'subSectionTitle'
			},
			{
				name: 'last_latitude',
				label: 'devices.last_latitude',
				permission: 'noc',
				type: 'label'
			},
			{
				name: 'last_longitude',
				label: 'devices.last_longitude',
				permission: 'noc',
				type: 'label'
			},
			{
				name: 'last_update_location_time_fmt',
				label: 'devices.last_update_location_time',
				permission: 'noc',
				type: 'label',
			}
		);
	}

	prepareDeviceSettingsForm() {
		if(DeviceFactory.isIMDeviceType(this.device.sct_device_type))
			return this.prepareIMDeviceSettingsForm();

		this.deviceSettingsFormFields = [
			{
				name: 'current_cable_scale',
				label: 'devices.current_cable_scale',
				permission: 'current_cable_scale',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.current_cable_scale,
				bindLabel: 'label',
				bindValue: 'id',
				validation: this.validationRules.current_cable_scale
			},
			{
				name: 'current_idle_to_charge',
				label: 'devices.current_idle_to_charge',
				permission: 'current_idle_to_charge',
				type: 'text',
				validation: [{"type": "float", "min": this.device.current_charge_to_idle, "max": 30}],
			},
			{
				name: 'current_idle_to_inuse',
				label: 'devices.current_idle_to_inuse',
				permission: 'current_idle_to_inuse',
				type: 'text',
				validation: [{"type": "float", "min": -30, "max": this.device.current_inuse_to_idle}],
			},
			{
				name: 'current_charge_to_idle',
				label: 'devices.current_charge_to_idle',
				permission: 'current_charge_to_idle',
				type: 'text',
				validation: [{"type": "float", "min": 1, "max": this.device.current_idle_to_charge}],
			},
			{
				name: 'current_charge_to_inuse',
				label: 'devices.current_charge_to_inuse',
				permission: 'current_charge_to_inuse',
				type: 'text',
				validation: [{"type": "float", "min": this.device.current_idle_to_inuse, "max": this.device.current_charge_to_idle}],
			},
			{
				name: 'current_inuse_to_charge',
				label: 'devices.current_inuse_to_charge',
				permission: 'current_inuse_to_charge',
				type: 'text',
				validation: [{"type": "float", "min": this.device.current_inuse_to_idle, "max": this.device.current_idle_to_charge}],
			},
			{
				name: 'current_inuse_to_idle',
				label: 'devices.current_inuse_to_idle',
				permission: 'current_inuse_to_idle',
				type: 'text',
				validation: [{"type": "float", "min": this.device.current_idle_to_inuse, "max": -1}],
			},
			{
				name: 'remote_flash_timer',
				label: 'devices.remote_flash_timer',
				permission: 'remote_flash_timer',
				type: 'number',
				validation: this.validationRules.remote_flash_timer
			}
		]

		if (this.deviceConfig.requiredFields.currentLiftUpperThreshold) {
			this.deviceSettingsFormFields.push(
				{
					name: 'current_lift_upper_threshold',
					label: 'devices.current_lift_upper_threshold',
					permission: 'current_lift_upper_threshold',
					type: 'text',
					validation: [{"type": "float", "max": this.device.current_lift_lower_threshold}],
					tooltip: !this.isFWSupportField('current_lift_upper_threshold')? 'disable_fields_fw_supported' : 'current_lift_upper_threshold_tooltip',
					disabled: !this.isFWSupportField('current_lift_upper_threshold'),
					error_message: this.translate.instant('devices.current_lift_upper_threshold_validation_message'),
				}
			)
		}

		if (this.deviceConfig.requiredFields.currentLiftLowerThreshold) {
			this.deviceSettingsFormFields.push(
				{
					name: 'current_lift_lower_threshold',
					label: 'devices.current_lift_lower_threshold',
					permission: 'current_lift_lower_threshold',
					type: 'text',
					validation: [{"type": "float", "min": this.device.current_lift_upper_threshold, "max": this.device.dead_man_current_limit}],
					tooltip: !this.isFWSupportField('current_lift_lower_threshold')? 'disable_fields_fw_supported' : 'current_lift_lower_threshold_tooltip',
					disabled: !this.isFWSupportField('current_lift_lower_threshold'),
				}
			)
		}

		if (this.deviceConfig.fields.deadManCurrentLimit) {
			this.deviceSettingsFormFields.push(
				{
					name: 'dead_man_current_limit',
					label: 'devices.dead_man_current_limit',
					permission: 'dead_man_current_limit',
					type: 'dropdown',
					items: this.deviceCommonService.ddLists.dead_man_current_limit,
					bindLabel: 'label',
					bindValue: 'id',
					validation: this.validationRules.dead_man_current_limit,
					tooltip: 'dead_man_current_limit'
				}
			)
		}

		if (this.deviceConfig.fields.hasWaterLevel) {
			this.deviceSettingsFormFields.push({
				name: 'has_water_level',
				label: 'devices.has_water_level',
				permission: 'has_water_level',
				type: 'boolean',
				validation: this.validationRules.has_water_level
			})
		}

		if (this.deviceConfig.fields.hasHallEffect) {
			this.deviceSettingsFormFields.push({
				name: 'hall_effect_sensor_type',
				label: 'devices.hall_effect_sensor_type',
				permission: 'hall_effect_sensor_type',
				type: 'dropdown',
				items: this.deviceCommonService.getHallEffectSensorTypes(this.device.fw_version, this.device.hall_effect_sensor_type),
				bindLabel: 'label',
				bindValue: 'id',
				validation: this.validationRules.hall_effect_sensor_type,
				disabled: !this.isFWSupportField('hall_effect_sensor_type'),
			});
		}

		if (this.deviceConfig.fields.hasTemperatureSensor) {
				this.deviceSettingsFormFields.push({
				name: 'has_temperature_sensor',
				label: 'devices.has_temperature_sensor',
				permission: 'has_temperature_sensor',
				type: 'boolean',
				validation: this.validationRules.has_temperature_sensor
			})
		};

		this.deviceSettingsFormFields.push(
			{
				name: 'charge_to_idle_timer',
				label: 'devices.charge_to_idle_timer',
				permission: 'charge_to_idle_timer',
				type: 'number',
				validation: this.validationRules.charge_to_idle_timer
			},
			{
				name: 'charge_to_inuse_timer',
				label: 'devices.charge_to_inuse_timer',
				permission: 'charge_to_inuse_timer',
				type: 'number',
				validation: this.validationRules.charge_to_inuse_timer
			},
			{
				name: 'inuse_to_charge_timer',
				label: 'devices.inuse_to_charge_timer',
				permission: 'inuse_to_charge_timer',
				type: 'number',
				validation: this.validationRules.inuse_to_charge_timer
			},
			{
				name: 'inuse_to_idle_timer',
				label: 'devices.inuse_to_idle_timer',
				permission: 'inuse_to_idle_timer',
				type: 'number',
				validation: this.validationRules.inuse_to_idle_timer
			},
			{
				name: 'idle_to_charge_timer',
				label: 'devices.idle_to_charge_timer',
				permission: 'idle_to_charge_timer',
				type: 'number',
				validation: this.validationRules.idle_to_charge_timer
			},
			{
				name: 'idle_to_inuse_timer',
				label: 'devices.idle_to_inuse_timer',
				permission: 'idle_to_inuse_timer',
				type: 'number',
				validation: this.validationRules.idle_to_inuse_timer
			},
			{
				name: 'time_hysteresis',
				label: 'devices.time_hysteresis',
				permission: 'time_hysteresis',
				type: 'number',
				validation: this.validationRules.time_hysteresis
			},
			{
				name: 'operation_mode',
				label: 'devices.operation_mode',
				permission: 'operation_mode',
				type: 'number',
				validation: this.validationRules.operation_mode
			},
			{
				name: 'replacement_part',
				label: 'devices.replacement_part',
				permission: 'replacement_part',
				type: 'boolean',
				validation: this.validationRules.replacement_part
			},
			{
				name: 'zone_id',
				label: 'devices.zone_id',
				permission: 'zone_id',
				type: 'dropdown',
				items: this.zones,
				bindLabel: 'display_name',
				bindValue: 'id',
				placeholder: 'g.select_time_zone',
				validation: this.validationRules.zone_id,
				tooltip: this.deviceService.getTranslationKey('zone_id', this.device),
			},
			{
				name: 'enable_rt',
				label: 'devices.enable_rt',
				permission: 'enable_rt',
				type: 'boolean',
				validation: this.validationRules.enable_rt
			},
			{
				name: 'rtLogFrequency',
				label: 'devices.rt_log_frequency',
				permission: 'rt_log_frequency',
				type: 'number',
				validation: this.validationRules.rtLogFrequency,
				disabled: !this.isFWSupportField('rt_log_frequency'),
				tooltip: !this.isFWSupportField('rt_log_frequency') ? this.deviceService.getTranslationKey('rt_frequency_log', this.device) : "",
			},
			{
				name: "rtLogFrequencyUnit",
				label: 'devices.rt_log_frequency_unit',
				permission: 'rt_log_frequency',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.rt_log_frequency_units,
				bindLabel: 'text',
				bindValue: 'value',
				placeholder: 'g.frequency_unit',
				disabled: !this.isFWSupportField('rt_log_frequency'),
				tooltip: !this.isFWSupportField('rt_log_frequency') ? this.deviceService.getTranslationKey('rt_frequency_log', this.device) : "",
			},
			{
				name: 'config_version',
				label: 'devices.config_version',
				permission: 'config_version',
				type: 'label'
			}
		);

		this.deviceSettingsFormFields.push(
			{
				name: 'has_current_low_range',
				label: 'devices.has_current_low_range',
				permission: 'has_current_low_range',
				type: 'boolean',
				validation: this.validationRules.has_current_low_range
			},
			{
				name: 'disable_external_rtc',
				label: 'devices.disable_external_rtc',
				permission: 'disable_external_rtc',
				type: 'boolean',
				validation: this.validationRules.disable_external_rtc,
				tooltip: !this.isFWSupportField('disable_external_rtc')? 'disable_fields_fw_supported' : false,
				disabled: !this.isFWSupportField('disable_external_rtc')
			},
			{
				name: 'disable_xtra',
				label: 'devices.disable_xtra',
				permission: 'disable_xtra',
				type: 'boolean',
				validation: this.validationRules.disable_xtra,
				tooltip: !this.isFWSupportField('disable_xtra')? 'disable_fields_fw_supported' : false,
				disabled: !this.isFWSupportField('disable_xtra')
			},
			{
				name: 'sct_device_type',
				label: 'devices.sct_device_type',
				permission: 'noc',
				type: 'dropdown',
				items: DeviceFactory.options,
				bindLabel: 'name',
				bindValue: 'id',
				validation: this.validationRules.sct_device_type
			},
			{
				name: 'enable_current_mask',
				label: 'devices.enable_current_mask',
				permission: 'enable_current_mask',
				type: 'boolean',
				validation: this.validationRules.enable_current_mask,
				tooltip: !this.isFWSupportField('enable_current_mask')? 'disable_enable_current_mask_fw_supported' : false,
				disabled: !this.isFWSupportField('enable_current_mask')
			},
		);
	}

	prepareIMDeviceSettingsForm() {
		this.deviceSettingsFormFields = [
			// {
			// 	name: 'energy_acc_threshold_outer',
			// 	label: this.deviceService.translate('devices.energy_acc_threshold_outer', this.device),
			// 	permission: 'energy_acc_threshold_outer',
			// 	type: 'number',
			// 	validation: this.validationRules.energy_acc_threshold_outer,
			// 	required: true,
			// },
			// {
			// 	name: 'energy_acc_threshold_inner',
			// 	label: this.deviceService.translate('devices.energy_acc_threshold_inner', this.device),
			// 	permission: 'energy_acc_threshold_inner',
			// 	type: 'number',
			// 	validation: this.validationRules.energy_acc_threshold_inner,
			// 	required: true,
			// },
			// {
			// 	name: 'energy_acc_seconds_valid_energy',
			// 	label: this.deviceService.translate('devices.energy_acc_seconds_valid_energy', this.device),
			// 	permission: 'energy_acc_seconds_valid_energy',
			// 	type: 'number',
			// 	validation: this.validationRules.energy_acc_seconds_valid_energy,
			// 	required: true,
			// },
			// {
			// 	name: 'energy_acc_seconds_no_energy',
			// 	label: this.deviceService.translate('devices.energy_acc_seconds_no_energy', this.device),
			// 	permission: 'energy_acc_seconds_no_energy',
			// 	type: 'number',
			// 	validation: this.validationRules.energy_acc_seconds_no_energy,
			// 	required: true,
			// },
		];

		this.deviceSettingsFormFields.push(
			{
				name: "over_voltage_threshold",
				label: this.device.voltage_reference != 0 ? this.deviceService.translate('devices.over_voltage_threshold_ln', this.device) : this.deviceService.translate('devices.over_voltage_threshold_ll', this.device),
				permission: "over_voltage_threshold",
				type: 'number',
				validation: this.validationRules.over_voltage_threshold,
				required: true,
			},
			{
				name: "under_voltage_threshold",
				label: this.device.voltage_reference != 0 ? this.deviceService.translate('devices.under_voltage_threshold_ln', this.device) : this.deviceService.translate('devices.under_voltage_threshold_ll', this.device),
				permission: "under_voltage_threshold",
				type: 'number',
				validation: this.validationRules.under_voltage_threshold,
				required: true,
			},
		);

		this.deviceSettingsFormFields.push(
			{
				name: 'over_current_threshold',
				label: this.deviceService.translate('devices.over_current_threshold', this.device),
				permission: 'over_current_threshold',
				type: 'number',
				validation: this.validationRules.over_current_threshold,
				required: true,
			},
			{
				name: 'modbus_enable',
				label: this.deviceService.translate('devices.modbus_enable', this.device),
				permission: 'modbus_enable',
				type: 'boolean',
				validation: this.validationRules.modbus_enable,
				asBoolean: true,
				disabled: true,
			},
			{
				name: 'reverse_energy_sign',
				label: this.deviceService.translate('devices.reverse_energy_sign', this.device),
				permission: 'reverse_energy_sign',
				type: 'boolean',
				validation: this.validationRules.reverse_energy_sign,
				asBoolean: true,
			},
			{
				name: 'remote_flash_timer',
				label: this.deviceService.translate('devices.remote_flash_timer', this.device),
				permission: 'remote_flash_timer',
				type: 'number',
				validation: this.validationRules.remote_flash_timer,
				required: true,
			},
			{
				name: 'zone_id',
				label: this.deviceService.translate('devices.zone_id', this.device),
				permission: 'zone_id',
				type: 'dropdown',
				items: this.zones,
				bindLabel: 'display_name',
				bindValue: 'id',
				placeholder: 'g.select_time_zone',
				validation: this.validationRules.zone_id,
			},
			{
				name: 'enable_rt',
				label: this.deviceService.translate('devices.enable_rt', this.device),
				permission: 'enable_rt',
				type: 'boolean',
				validation: this.validationRules.enable_rt,
				asBoolean: true,
			},
			{
				name: 'rtLogFrequency',
				label: this.deviceService.translate('devices.rt_log_frequency', this.device),
				permission: 'rt_log_frequency',
				type: 'number',
				validation: this.validationRules.rtLogFrequency,
			},
			{
				name: "rtLogFrequencyUnit",
				label: this.deviceService.translate('devices.rt_log_frequency_unit', this.device),
				permission: 'rt_log_frequency',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.rt_log_frequency_units,
				bindLabel: 'text',
				bindValue: 'value',
				placeholder: 'g.frequency_unit',
			},
			{
				name: 'ct_ratio',
				label: this.deviceService.translate('devices.ct_ratio', this.device),
				permission: 'ct_ratio',
				type: 'dropdown',
				items: this.device.is_rct ? this.deviceCommonService.ddLists.ctRatioRogowskiType : this.deviceCommonService.ddLists.ctRatioOptions,
				bindLabel: 'text',
				bindValue: 'id',
				validation: this.validationRules.ct_ratio,
			},
			// {
			// 	name: '_virtual_service_type',
			// 	label: this.deviceService.translate('devices._virtual_service_type', this.device),
			// 	permission: '_virtual_service_type',
			// 	type: 'dropdown',
			// 	items: this.deviceCommonService.ddLists.serviceTypes,
			// 	bindLabel: 'label',
			// 	bindValue: 'id',
			// 	validation: this.validationRules._virtual_service_type,
			// },
			{
				name: 'voltage_reference',
				label: this.deviceService.translate('devices.voltage_reference', this.device),
				permission: 'voltage_reference',
				type: 'dropdown',
				items: this.getVoltageReferenceOptions(),
				bindLabel: 'text',
				bindValue: 'value',
				required: true,
			},
			{
				name: 'wiring_mode',
				label: this.deviceService.translate('devices.wiring_mode', this.device),
				permission: 'wiring_mode',
				type: 'dropdown',
				items: Object.values(this.deviceCommonService.ddLists.wiringModeSettings),
				bindLabel: 'text',
				bindValue: 'value',
				validation: this.validationRules.wiring_mode,
				required: true,
				disabled: this.device.hw_version < 'C',
				labelUnderInputCssClass: 'text-danger fw-bold',
			},
			{
				name: 'sct_device_type',
				label: 'devices.sct_device_type',
				permission: 'noc',
				type: 'dropdown',
				items: this.device.sct_device_type == DeviceFactory.types.ioTEmeterEdge ? DeviceFactory.ImeterOptionsType.filter(item => item.id == DeviceFactory.types.ioTEmeterEdge) : this.deviceService.imDevicesTypeOptions,
				bindLabel: 'name',
				bindValue: 'id',
				validation: this.validationRules.sct_device_type
			},
			{
				name: 'iotemeter_id',
				label: 'devices.iotemeter_id',
				permission: 'iotemeter_id',
				type: 'text',
				items: this.device.sct_device_type == DeviceFactory.types.ioTEmeterEdge ? DeviceFactory.ImeterOptionsType.filter(item => item.id == DeviceFactory.types.ioTEmeterEdge) : this.deviceService.imDevicesTypeOptions,
				validation: this.validationRules.iotemeter_id
			},
			{
				name: 'enabled_wires',
				label: this.deviceService.translate('devices.enabled_wires', this.device),
				permission: 'enabled_wires',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.wiringModeSettings[this.device.wiring_mode].enabledWiresOptions,
				bindLabel: 'text',
				bindValue: 'value',
				validation: this.validationRules.enabled_wires,
				required: true,
			},
		);

		if (this.deviceConfig.hasImCalibration) {
			this.deviceSettingsFormFields.push(
				{
					name: 'system_ac_load_enable',
					label: 'devices.system_ac_load_enable',
					permission: 'system_ac_load_enable',
					type: 'boolean',
				},
				{
					name: 'system_aux_load_enable',
					label: 'devices.system_aux_load_enable',
					permission: 'system_aux_load_enable',
					type: 'boolean',
				},
				{
					name: 'rt_check_enable',
					label: 'devices.rt_check_enable',
					permission: 'rt_check_enable',
					type: 'boolean',
				},
				{
					name: 'rt_voltage_threshold',
					label: 'devices.rt_voltage_threshold',
					permission: 'rt_voltage_threshold',
					type: 'text',
				},
				{
					name: 'rt_current_threshold',
					label: 'devices.rt_current_threshold',
					permission: 'rt_current_threshold',
					type: 'text',
				},
				{
					name: 'rt_tot_power_threshold',
					label: 'devices.rt_tot_power_threshold',
					permission: 'rt_tot_power_threshold',
					type: 'text',
				},
				{
					name: 'rt_pf_threshold',
					label: 'devices.rt_pf_threshold',
					permission: 'rt_pf_threshold',
					type: 'text',
				},
				{
					name: 'rt_line_frequency_com_threshold',
					label: 'devices.rt_line_frequency_com_threshold',
					permission: 'rt_line_frequency_com_threshold',
					type: 'text',
				},
				{
					name: 'rt_voltage_ll_threshold',
					label: 'devices.rt_voltage_ll_threshold',
					permission: 'rt_voltage_ll_threshold',
					type: 'text',
				},
				{
					name: 'ade_90xx_calibration_status',
					label: 'devices.ade_90xx_calibration_status',
					permission: 'ade_90xx_calibration_status',
					type: 'boolean',
				},
				{
					name: 'power_on_start_delay_secs',
					label: 'devices.power_on_start_delay_secs',
					permission: 'power_on_start_delay_secs',
					type: 'text',
				},
				{
					name: 'power_on_start',
					label: 'devices.power_on_start',
					permission: 'power_on_start',
					type: 'boolean',
				},
				{
					name: 'shipping_mode_enabled',
					label: 'devices.shipping_mode_enabled',
					permission: 'shipping_mode_enabled',
					type: 'boolean',
				},
				{
					name: 'battery_enable',
					label: 'devices.battery_enable',
					permission: 'battery_enable',
					type: 'boolean',
				},
				{
					name: 'user_ac_load_enable',
					label: 'devices.user_ac_load_enable',
					permission: 'user_ac_load_enable',
					type: 'boolean',
				},
				{
					name: 'user_aux_load_enable',
					label: 'devices.user_aux_load_enable',
					permission: 'user_aux_load_enable',
					type: 'boolean',
				},
				{
					name: 'ac_relay_open_current',
					label: 'devices.ac_relay_open_current',
					permission: 'ac_relay_open_current',
					type: 'text',
				},
				{
					name: 'enable_rt_average',
					label: 'devices.enable_rt_average',
					permission: 'enable_rt_average',
					type: 'boolean',
				},
				{
					name: 'disable_external_rtc',
					label: 'devices.disable_external_rtc',
					permission: 'disable_external_rtc',
					type: 'boolean',
				},
				{
					name: ['ade90xx_settings', 'sel_freq'],
					label: 'devices.sel_freq',
					permission: 'ade90xx_settings.sel_freq',
					type: 'dropdown',
					items: this.selfreqOptions,
					bindLabel: 'text',
					bindValue: 'value',
				},
				{
					name: ['ade90xx_settings', 'ade_type'],
					label: 'devices.ade_type',
					permission: 'ade90xx_settings.ade_type',
					type: 'dropdown',
					bindLabel: 'label',
					bindValue: 'value',
					items: this.adeTypeOptions,
				},
			);
		}
	}

	prepareEventTypeSettingsForm() {
		const fwDisabled = +this.device.fw_version < this.minFWVersionToEditEventType;
		this.eventTypeSettingsFWDisabled = fwDisabled;

		this.eventTypeSettingsFormFields = [
			{
				name: 'event_logic',
				label: this.translate.instant('devices.events_type'),
				permission: 'event_logic',
				type: 'dropdown',
				items: [
					{ id: this.deviceService.eventLogic.daily, label: this.translate.instant('devices.daily_event_type') },
					{ id: this.deviceService.eventLogic.stateBased, label: this.translate.instant('devices.state_based_event_type') },
				],
				bindLabel: 'label',
				bindValue: 'id',
				validation: this.validationRules.event_logic,
				disabled: fwDisabled,
			},
		];

		for (const field of this.stateBasedEventFields) {
			// The power thresholds keep the shared field rules, so the web and the server agree on what a Daily
			// save accepts. That leaves the shared minimum to reject a negative value before the tab check runs,
			// so it carries the wording of the rule it is standing in for rather than "should be at least 0".
			const isPowerThreshold = this.deviceService.imPowerThresholdFields.includes(field);

			this.eventTypeSettingsFormFields.push({
				name: field,
				label: this.translate.instant(`devices.${field}`),
				permission: field,
				type: 'number',
				min: 0,
				validation: this.validationRules[field],
				error_message: isPowerThreshold
					? this.translate.instant('devices.power_threshold_greater_than_zero', {
						field: this.translate.instant(`devices.${field}_short`),
					})
					: undefined,
				required: true,
				disabled: fwDisabled,
			});
		}
	}

	private getVoltageReferenceOptions(wiring_mode?: any) {
		wiring_mode = wiring_mode != undefined ? wiring_mode : this.device.wiring_mode;

		if (this.deviceCommonService.ddLists.wiringModeSettings[wiring_mode] && this.deviceCommonService.ddLists.wiringModeSettings[wiring_mode].voltageReferenceDefault)
			return [this.deviceCommonService.ddLists.voltageReferenceOptions[this.deviceCommonService.ddLists.wiringModeSettings[wiring_mode].voltageReferenceDefault]];
		return Object.values(this.deviceCommonService.ddLists.voltageReferenceOptions);
	}

	prepareBatterySettingsForm() {
		this.batterySettingsFormFields = [
			{
				name: 'fi_duration',
				label: 'devices.fi_duration',
				permission: 'fi_duration',
				type: 'number',
				validation: this.validationRules.fi_duration
			},
			{
				name: 'eq_duration',
				label: 'devices.eq_duration',
				permission: 'eq_duration',
				type: 'number',
				validation: this.validationRules.eq_duration
			},
			{
				name: 'vpc',
				label: 'devices.vpc',
				permission: 'vpc',
				type: 'text',
				validation: this.validationRules.vpc
			}
		];

		if (this.deviceConfig.fields.trickleVoltage) {
			this.batterySettingsFormFields.push({
				name: 'trickle_voltage',
				label: 'devices.trickle_voltage',
				permission: 'trickle_voltage',
				type: 'number',
				validation: this.validationRules.trickle_voltage
			})
		}

		if (this.deviceConfig.fields.cvTargetVoltage) {
			this.batterySettingsFormFields.push({
				name: 'cv_target_voltage',
				label: 'devices.cv_target_voltage',
				permission: 'cv_target_voltage',
				type: 'text',
				validation: this.validationRules.cv_target_voltage
			})
		}

		if (this.deviceConfig.fields.fiTargetVoltage) {
			this.batterySettingsFormFields.push({
				name: 'fi_target_voltage',
				label: 'devices.fi_target_voltage',
				permission: 'fi_target_voltage',
				type: 'text',
				validation: this.validationRules.fi_target_voltage
			})
		}

		if (this.deviceConfig.fields.eqVoltage) {
			this.batterySettingsFormFields.push({
				name: 'eq_voltage',
				label: 'devices.eq_voltage',
				permission: 'eq_voltage',
				type: 'text',
				validation: this.validationRules.eq_voltage
			})
		}

		if (this.deviceConfig.fields.trickleCurrentRate) {
			this.batterySettingsFormFields.push({
				name: 'trickle_current_rate',
				label: 'devices.trickle_current_rate',
				permission: 'trickle_current_rate',
				type: 'text',
				validation: this.validationRules.trickle_current_rate
			})
		}

		if (this.deviceConfig.fields.ccRate) {
			this.batterySettingsFormFields.push({
				name: 'cc_rate',
				label: 'devices.cc_rate',
				permission: 'cc_rate',
				type: 'text',
				validation: this.validationRules.cc_rate
			})
		}

		if (this.deviceConfig.fields.cvEndCurrentRate) {
			this.batterySettingsFormFields.push({
				name: 'cv_end_current_rate',
				label: 'devices.cv_end_current_rate',
				permission: 'cv_end_current_rate',
				type: 'text',
				validation: this.validationRules.cv_end_current_rate
			})
		}

		if (this.deviceConfig.fields.cvCurrentStep) {
			this.batterySettingsFormFields.push({
				name: 'cv_current_step',
				label: 'devices.cv_current_step',
				permission: 'cv_current_step',
				type: 'text',
				validation: this.validationRules.cv_current_step
			})
		}

		if (this.deviceConfig.fields.fiCurrentRate) {
			this.batterySettingsFormFields.push({
				name: 'fi_current_rate',
				label: 'devices.fi_current_rate',
				permission: 'fi_current_rate',
				type: 'text',
				validation: this.validationRules.fi_current_rate
			})
		}

		if (this.deviceConfig.fields.eqCurrentRate) {
			this.batterySettingsFormFields.push({
				name: 'eq_current_rate',
				label: 'devices.eq_current_rate',
				permission: 'eq_current_rate',
				type: 'text',
				validation: this.validationRules.eq_current_rate
			})
		}

		if (this.deviceConfig.fields.batteryCapacity) {
			this.batterySettingsFormFields.push({
				name: 'battery_capacity',
				label: 'devices.battery_capacity',
				permission: 'battery_capacity',
				type: 'number',
				validation: this.validationRules.battery_capacity,
				tooltip: 'battery_capacity'
			})
		}

		if (this.deviceConfig.fields.batteryType) {
			this.batterySettingsFormFields.push({
				name: 'battery_type',
				label: 'devices.battery_type',
				permission: 'battery_type',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.battery_type,
				bindLabel: 'label',
				bindValue: 'id',
				validation: this.validationRules.battery_type,
				tooltip: 'battery_type'
			})
		}

		if (this.deviceConfig.fields.numberOfCells) {
			this.batterySettingsFormFields.push({
				name: 'number_of_cells',
				label: 'devices.number_of_cells',
				permission: 'number_of_cells',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.number_of_cells,
				bindLabel: 'label',
				bindValue: 'id',
				validation: this.validationRules.number_of_cells,
				tooltip: 'number_of_cells'
			})
		}

		if (this.deviceConfig.fields.batteryTemperatureCompensationInMv) {
			this.batterySettingsFormFields.push({
				name: 'battery_temperature_compensation_in_mv',
				label: 'devices.battery_temperature_compensation_in_mv',
				permission: 'battery_temperature_compensation_in_mv',
				type: 'number',
				validation: this.validationRules.battery_temperature_compensation_in_mv
			})
		}

		if (this.deviceConfig.fields.fiDt) {
			this.batterySettingsFormFields.push({
				name: 'fi_dt',
				label: 'devices.fi_dt',
				permission: 'fi_dt',
				type: 'number',
				validation: this.validationRules.fi_dt
			})
		}

		if (this.deviceConfig.fields.fiDv) {
			this.batterySettingsFormFields.push({
				name: 'fi_dv',
				label: 'devices.fi_dv',
				permission: 'fi_dv',
				type: 'number',
				validation: this.validationRules.fi_dv
			})
		}

		if (this.deviceConfig.fields.liftCurrentThresholdPercentage) {
			this.batterySettingsFormFields.push({
				name: 'lift_current_threshold_percentage',
				label: 'devices.lift_current_threshold_percentage',
				permission: 'lift_current_threshold_percentage',
				type: 'number',
				validation: this.validationRules.lift_current_threshold_percentage,
				tooltip: !this.isFWSupportField('lift_current_threshold_percentage')? 'disable_fields_fw_supported' : 'lift_current_threshold_percentage_tooltip',
				disabled: !this.isFWSupportField('lift_current_threshold_percentage')
			})
		}

		if (this.deviceConfig.fields.liftCurrentThresholdValue) {
			this.batterySettingsFormFields.push({
				name: 'lift_current_threshold_value',
				label: 'devices.lift_current_threshold_value',
				permission: 'lift_current_threshold_value',
				type: 'number',
				disabled: true,
				tooltip: 'lift_current_threshold_value_tooltip'
			})
		}

		if (this.deviceConfig.fields.liftCurrentThresholdDeltaPercentage) {
			this.batterySettingsFormFields.push({
				name: 'lift_current_threshold_delta_percentage',
				label: 'devices.lift_current_threshold_delta_percentage',
				permission: 'lift_current_threshold_delta_percentage',
				type: 'number',
				validation: this.validationRules.lift_current_threshold_delta_percentage,
				tooltip: !this.isFWSupportField('lift_current_threshold_delta_percentage')? 'disable_fields_fw_supported' : 'lift_current_threshold_delta_percentage_tooltip',
				disabled: !this.isFWSupportField('lift_current_threshold_delta_percentage')
			})
		}

		if (this.deviceConfig.fields.liftCurrentThresholdDeltaValue) {
			this.batterySettingsFormFields.push({
				name: 'lift_current_threshold_delta_value',
				label: 'devices.lift_current_threshold_delta_value',
				permission: 'lift_current_threshold_delta_value',
				type: 'number',
				disabled: true,
				tooltip: 'lift_current_threshold_delta_value_tooltip'
			})
		}

		if (this.deviceConfig.fields.chargerType) {
			this.batterySettingsFormFields.push(
				{
					name: 'charger_type',
					label: 'devices.charger_type',
					bindLabel: 'label',
					bindValue: 'value',
					permission: 'charger_type',
					validation:  this.validationRules.charger_type,
					type: 'dropdown',
					items: this.deviceCommonService.chargersType,
				}
			);
		}

		this.batterySettingsFormFields.push({
			name: 'max_battery_temperature',
			label: 'devices.max_battery_temperature',
			permission: 'max_battery_temperature',
			type: 'number',
			validation: this.validationRules.max_battery_temperature,
			tooltip: !this.isFWSupportField('max_battery_temperature') ? 'disable_max_battery_temperature_fw_supported' : false,
			disabled: !this.isFWSupportField('max_battery_temperature')
		});

		this.batterySettingsFormFields.push({
			name: 'cool_down_temperature',
			label: 'devices.cool_down_temperature',
			permission: 'cool_down_temperature',
			type: 'number',
			validation: this.validationRules.cool_down_temperature,
			tooltip: !this.isFWSupportField('cool_down_temperature') ? 'disable_cool_down_temperature_fw_supported' : false,
			disabled: !this.isFWSupportField('cool_down_temperature')
		});
	}

	prepareCalForm() {
		this.calFormFields = [
			{
				name: 'current_drift_adc_low_range',
				label: 'devices.current_drift_adc_low_range',
				permission: 'current_drift_adc_low_range',
				type: 'text',
				validation: this.validationRules.current_drift_adc_low_range
			},
			{
				name: 'voltage_drift_adc',
				label: 'devices.voltage_drift_adc',
				permission: 'voltage_drift_adc',
				type: 'text',
				validation: this.validationRules.voltage_drift_adc
			},
			{
				name: 'voltage_scale_adc',
				label: 'devices.voltage_scale_adc',
				permission: 'voltage_scale_adc',
				type: 'text',
				validation: this.validationRules.voltage_scale_adc
			},
			{
				name: 'current_drift_adc',
				label: 'devices.current_drift_adc',
				permission: 'current_drift_adc',
				type: 'text',
				validation: this.validationRules.current_drift_adc
			},
			{
				name: 'current_scale_adc',
				label: 'devices.current_scale_adc',
				permission: 'current_scale_adc',
				type: 'text',
				validation: this.validationRules.current_scale_adc
			},
			{
				name: 'temperature_beta',
				label: 'devices.temperature_beta',
				permission: 'temperature_beta',
				type: 'text',
				validation: this.validationRules.temperature_beta
			},
			{
				name: 'current_scale_adc_low_range',
				label: 'devices.current_scale_adc_low_range',
				permission: 'current_scale_adc_low_range',
				type: 'text',
				validation: this.validationRules.current_scale_adc_low_range
			},
			{
				name: 'temperature_res_dividor',
				label: 'devices.temperature_res_dividor',
				permission: 'temperature_res_dividor',
				type: 'text',
				validation: this.validationRules.temperature_res_dividor
			},
			{
				name: 'temperature_res_drift',
				label: 'devices.temperature_res_drift',
				permission: 'temperature_res_drift',
				type: 'text',
				validation: this.validationRules.temperature_res_drift
			},
			{
				name: 'temperature_res_dividor_drift',
				label: 'devices.temperature_res_dividor_drift',
				permission: 'temperature_res_dividor_drift',
				type: 'text',
				validation: this.validationRules.temperature_res_dividor_drift
			},
			{
				name: 'probe_drift_adc',
				label: 'devices.probe_drift_adc',
				permission: 'probe_drift_adc',
				type: 'text',
				validation: this.validationRules.probe_drift_adc
			},
			{
				name: 'probe_scale_adc',
				label: 'devices.probe_scale_adc',
				permission: 'probe_scale_adc',
				type: 'text',
				validation: this.validationRules.probe_scale_adc
			},
			{
				name: 'gallons_count_scale',
				label: 'devices.gallons_count_scale',
				permission: 'gallons_count_scale',
				type: 'text',
				validation: this.validationRules.gallons_count_scale
			},
			{
				name: 'high_probe_voltage',
				label: 'devices.high_probe_voltage',
				permission: 'high_probe_voltage',
				type: 'text',
				validation: this.validationRules.high_probe_voltage
			},
		];

		if (this.deviceConfig.hasImCalibration) {
			this.calFormFields = [
				{
					name: ['ade90xx_settings', 'v_a_gain'],
					label: 'devices.v_a_gain',
					permission: 'ade90xx_settings.v_a_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'v_b_gain'],
					label: 'devices.v_b_gain',
					permission: 'ade90xx_settings.v_b_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'v_c_gain'],
					label: 'devices.v_c_gain',
					permission: 'ade90xx_settings.v_c_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'i_a_gain'],
					label: 'devices.i_a_gain',
					permission: 'ade90xx_settings.i_a_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'i_b_gain'],
					label: 'devices.i_b_gain',
					permission: 'ade90xx_settings.i_b_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'i_c_gain'],
					label: 'devices.i_c_gain',
					permission: 'ade90xx_settings.i_c_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'i_n_gain'],
					label: 'devices.i_n_gain',
					permission: 'ade90xx_settings.i_n_gain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'aigain'],
					label: 'devices.aigain',
					permission: 'ade90xx_settings.aigain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bigain'],
					label: 'devices.bigain',
					permission: 'ade90xx_settings.bigain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cigain'],
					label: 'devices.cigain',
					permission: 'ade90xx_settings.cigain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'nigain'],
					label: 'devices.nigain',
					permission: 'ade90xx_settings.nigain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'avgain'],
					label: 'devices.avgain',
					permission: 'ade90xx_settings.avgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bvgain'],
					label: 'devices.bvgain',
					permission: 'ade90xx_settings.bvgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cvgain'],
					label: 'devices.cvgain',
					permission: 'ade90xx_settings.cvgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'airmsos'],
					label: 'devices.airmsos',
					permission: 'ade90xx_settings.airmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'birmsos'],
					label: 'devices.birmsos',
					permission: 'ade90xx_settings.birmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cirmsos'],
					label: 'devices.cirmsos',
					permission: 'ade90xx_settings.cirmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'nirmsos'],
					label: 'devices.nirmsos',
					permission: 'ade90xx_settings.nirmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'avrmsos'],
					label: 'devices.avrmsos',
					permission: 'ade90xx_settings.avrmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bvrmsos'],
					label: 'devices.bvrmsos',
					permission: 'ade90xx_settings.bvrmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cvrmsos'],
					label: 'devices.cvrmsos',
					permission: 'ade90xx_settings.cvrmsos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'aphcal0'],
					label: 'devices.aphcal0',
					permission: 'ade90xx_settings.aphcal0',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bphcal0'],
					label: 'devices.bphcal0',
					permission: 'ade90xx_settings.bphcal0',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cphcal0'],
					label: 'devices.cphcal0',
					permission: 'ade90xx_settings.cphcal0',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'apgain'],
					label: 'devices.apgain',
					permission: 'ade90xx_settings.apgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bpgain'],
					label: 'devices.bpgain',
					permission: 'ade90xx_settings.bpgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cpgain'],
					label: 'devices.cpgain',
					permission: 'ade90xx_settings.cpgain',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'aptos'],
					label: 'devices.aptos',
					permission: 'ade90xx_settings.aptos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bptos'],
					label: 'devices.bptos',
					permission: 'ade90xx_settings.bptos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cptos'],
					label: 'devices.cptos',
					permission: 'ade90xx_settings.cptos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'aqtos'],
					label: 'devices.aqtos',
					permission: 'ade90xx_settings.aqtos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'bqtos'],
					label: 'devices.bqtos',
					permission: 'ade90xx_settings.bqtos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'cqtos'],
					label: 'devices.cqtos',
					permission: 'ade90xx_settings.cqtos',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'var_acc'],
					label: 'devices.var_acc',
					permission: 'ade90xx_settings.var_acc',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'watt_acc'],
					label: 'devices.watt_acc',
					permission: 'ade90xx_settings.watt_acc',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'burden_res'],
					label: 'devices.burden_res',
					permission: 'ade90xx_settings.burden_res',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'r1'],
					label: 'devices.r1',
					permission: 'ade90xx_settings.r1',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'r2'],
					label: 'devices.r2',
					permission: 'ade90xx_settings.r2',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'vconsel'],
					label: 'devices.vconsel',
					permission: 'ade90xx_settings.vconsel',
					type: 'text',
				},
				{
					name: ['ade90xx_settings', 'iconsel'],
					label: 'devices.iconsel',
					permission: 'ade90xx_settings.iconsel',
					type: 'text',
				},
			];
		}
	}

	prepareNetworkingSettingsForm() {
		// the route checks access to one device, a list of MACs is rejected as not authorized and the form was never built (ST-2746)
		const shippingConnectivity$ = this.multiDevices ? of([]) : this.deviceService.getShippingConnectivityData(this.device.mac_address);
		shippingConnectivity$.subscribe((data: any) => {
			let disableCellularReconnectTime = false;
			let revertTimeDate = null;
			if(data[0]) {
				revertTimeDate = moment(data[0].action_time).toDate();
				const currentTime = new Date();
				disableCellularReconnectTime = revertTimeDate > currentTime;
			}

			this.networkingSettingsFormFields = [];

			if (!this.isIMDevice) {
				this.networkingSettingsFormFields.push(
					{
						name: 'soft_ap_exit',
						label: 'devices.soft_ap_exit',
						permission: 'soft_ap_exit',
						type: 'text',
						validation: this.validationRules.soft_ap_exit
					},
					{
						name: 'soft_ap_exit_no_setup',
						label: 'devices.soft_ap_exit_no_setup',
						permission: 'soft_ap_exit_no_setup',
						type: 'text',
						validation: this.validationRules.soft_ap_exit_no_setup
					},
				);
			}

			if (!this.isIMDevice || (this.isIMDevice && !this.multiDevices)) {
				this.networkingSettingsFormFields.push(
					{
						name: 'remoter_server_port',
						label: 'devices.remoter_server_port',
						permission: 'remoter_server_port',
						type: 'text',
						validation: this.validationRules.remoter_server_port,
					},
					{
						name: 'mobile_port',
						label: 'devices.mobile_port',
						permission: 'mobile_port',
						type: 'text',
						validation: this.validationRules.mobile_port
					},
					{
						name: 'master_port',
						label: 'devices.master_port',
						permission: 'master_port',
						type: 'text',
						validation: this.validationRules.master_port
					},
					{
						name: 'reconnect_time',
						label: 'devices.reconnect_time',
						permission: 'reconnect_time',
						type: 'text',
						validation: this.validationRules.reconnect_time
					},
					{
						name: 'remoter_server_ip_options',
						label: 'devices.remoter_server_ip',
						permission: 'remoter_server_ip',
						type: 'dropdown',
						items: this.deviceCommonService.getRemoteServerType(this.device.fw_version, this.isIMDevice, this.device.sct_device_type),
						bindLabel: 'text',
						bindValue: 'id',
						validation: this.validationRules.remoter_server_ip
					},
					{
						name: 'remoter_server_ip',
						label: '',
						permission: 'remoter_server_ip',
						type: 'text',
						editable: {relatedField: 'remoter_server_ip_options', relatedValues: ['production', 'staging', 'development']},
						validation: this.validationRules.remoter_server_ip
					},
					{
						name: 'enable_multicast',
						label: 'devices.enable_multicast',
						permission: 'enable_multicast',
						type: 'boolean',
						validation: this.validationRules.enable_multicast,
						asBoolean: this.isIMDevice,
					},
					{
						name: 'multicast_port',
						label: 'devices.multicast_port',
						permission: 'multicast_port',
						type: 'text',
						validation: this.validationRules.multicast_port
					},
					{
						name: 'multicast_ip',
						label: 'devices.multicast_ip',
						permission: 'multicast_ip',
						type: 'text',
						validation: this.validationRules.multicast_ip
					},
					{
						name: 'ap_password',
						label: 'devices.ap_password',
						permission: 'ap_password',
						type: 'password',
						validation: this.validationRules.ap_password
					},
					{
						name: 'ap_ssid',
						label: 'devices.ap_ssid',
						permission: 'ap_ssid',
						type: 'text',
						validation: this.validationRules.ap_ssid
					},

					{
						name: 'enable_wifi_ap_on_start',
						label: 'devices.enable_wifi_ap_on_start',
						permission: 'enable_wifi_ap_on_start',
						type: 'boolean',
						validation: this.validationRules.enable_wifi_ap_on_start,
						asBoolean: this.isIMDevice,
					},
					{
						name: 'ap_channel',
						label: 'devices.ap_channel',
						permission: 'ap_channel',
						type: 'text',
						validation: this.validationRules.ap_channel
					},
					{
						name: 'enable_serversocket',
						label: 'devices.enable_serversocket',
						permission: 'enable_serversocket',
						type: 'boolean',
						validation: this.validationRules.enable_serversocket,
						asBoolean: this.isIMDevice,
					},
					{
						name: 'enc_code',
						label: 'devices.enc_code',
						permission: 'enc_code',
						type: 'text',
						validation: this.validationRules.enc_code
					},
				);
			}

			if (!this.isIMDevice) {
				this.networkingSettingsFormFields.push(
					{
						name: 'is_online_enabled',
						label: 'devices.is_online_enabled',
						permission: 'is_online_enabled',
						type: 'boolean',
						validation: this.validationRules.is_online_enabled
					},
				);
			}

			if (!this.isIMDevice || (this.isIMDevice && !this.multiDevices)) {
				this.networkingSettingsFormFields.push(
					{
						name: 'server_socket_port',
						label: 'devices.server_socket_port',
						permission: 'server_socket_port',
						type: 'text',
						validation: this.validationRules.server_socket_port
					},
					{
						name: 'enable_cellular',
						label: 'devices.enable_cellular',
						permission: 'enable_cellular',
						type: 'boolean',
						validation: this.validationRules.enable_cellular,
						asBoolean: this.isIMDevice,
					},
				);
			};

			this.networkingSettingsFormFields.push(
				{
					name: 'cellular_region',
					label: 'devices.cellular_region',
					permission: 'cellular_region',
					type: 'dropdown',
					items: this.deviceCommonService.ddLists.cellular_region,
					bindLabel: 'text',
					bindValue: 'id',
					validation: this.validationRules.cellular_region,
				},
			);

			if (this.isIMDevice && !this.multiDevices) {
				this.networkingSettingsFormFields.push(
					{
						name: 'static_cellular_ip',
						label: 'devices.static_cellular_ip',
						permission: 'static_cellular_ip',
						type: 'text',
						validation: this.validationRules.static_cellular_ip,
					},
					{
						name: 'static_cellular_gw',
						label: 'devices.static_cellular_gw',
						permission: 'static_cellular_gw',
						type: 'text',
						validation: this.validationRules.static_cellular_gw,
					},
					{
						name: 'static_cellular_netmask',
						label: 'devices.static_cellular_netmask',
						permission: 'static_cellular_netmask',
						type: 'text',
						validation: this.validationRules.static_cellular_netmask,
					},
				);
			}

			this.networkingSettingsFormFields.push(
				{
					name: this.isIMDevice ? 'cell_acces_point_name' : 'cell_access_point_name',
					label: 'devices.cell_access_point_name',
					permission: this.isIMDevice ? 'cell_acces_point_name' : 'cell_access_point_name',
					type: 'text',
					validation: this.validationRules.cell_access_point_name
				},
				{
					name: 'lte_cellular_bands',
					label: 'devices.lte_cellular_bands',
					permission: 'lte_cellular_bands',
					type: 'dropdown',
					items: this.deviceCommonService.ddLists.lte_bands,
					bindLabel: 'text',
					bindValue: 'value',
					multiple: true,
					required: true,
					validation: this.validationRules.lte_cellular_bands,
					error_message: this.translate.instant('devices.lte_cellular_bands_error'),
				},
				{
					name: 'nbiot_cellular_bands',
					label: 'devices.nbiot_cellular_bands',
					permission: 'nbiot_cellular_bands',
					type: 'dropdown',
					items: this.deviceCommonService.ddLists.nbiot_bands,
					bindLabel: 'text',
					bindValue: 'value',
					multiple: true,
					validation: this.validationRules.nbiot_cellular_bands,
				},
				{
					name: 'cellular_reconnect_time',
					label: 'devices.cellular_reconnect_time',
					permission: 'cellular_reconnect_time',
					type: 'text',
					validation: this.validationRules.cellular_reconnect_time,
					disabled: disableCellularReconnectTime,
					tooltip: disableCellularReconnectTime ? this.translate.instant('connectivity_frequency.tooltip') + moment(revertTimeDate).format('MM/DD/yy hh:mm:ss A') : false,
					tooltipIsTranslated: true
				},
			);

			this.networkingSettingsFormFields.push(
				{
					name: this.isIMDevice ? 'metered_connection' : 'metered_flag',
					label: 'devices.metered_flag',
					permission: this.isIMDevice ? 'metered_connection' : 'metered_flag',
					type: 'dropdown',
					items: this.deviceCommonService.ddLists.metered_flag,
					bindLabel: 'label',
					bindValue: 'value',
					validation: this.validationRules.metered_flag
				},
			);
		});
	}

	prepareNetworkingForm() {
		this.networkingFormFields = [
			{
				name: 'enable_wifi_sta',
				label: 'devices.enable_wifi_sta',
				permission: 'enable_wifi_sta',
				type: 'boolean',
				validation: this.validationRules.enable_wifi_sta,
				asBoolean: this.isIMDevice,
			},
			{
				name: ['mobile_master', 'ssid'],
				label: 'devices.mobile_master_ssid',
				permission: 'mobile_master.ssid',
				type: 'text',
				validation: this.validationRules.mobile_master.ssid,
				required: true
			},
			{
				name: ['mobile_master', 'password'],
				label: 'devices.mobile_master_password',
				permission: 'mobile_master.password',
				type: 'password',
				validation: this.validationRules.mobile_master.password,
			},
			{
				name: ['mobile_master', 'priority'],
				label: 'devices.mobile_master_priority',
				permission: 'mobile_master.priority',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.networkPriorities,
				bindLabel: 'text',
				bindValue: 'id',
				validation: this.validationRules.mobile_master.priority
			},
			{
				name: ['mobile_network', 'ssid'],
				label: 'devices.mobile_network_ssid',
				permission: 'mobile_network.ssid',
				type: 'text',
				validation: this.validationRules.mobile_network.ssid,
				required: true
			},
			{
				name: ['mobile_network', 'password'],
				label: 'devices.mobile_network_password',
				permission: 'mobile_network.password',
				type: 'password',
				validation: this.validationRules.mobile_network.password,
			},
			{
				name: ['mobile_network', 'priority'],
				label: 'devices.mobile_network_priority',
				permission: 'mobile_network.priority',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.networkPriorities,
				bindLabel: 'text',
				bindValue: 'id',
				validation: this.validationRules.mobile_network.priority
			},
			{
				name: ['router_network', 'ssid'],
				label: 'devices.router_network_ssid',
				permission: 'router_network.ssid',
				type: 'text',
				validation: this.validationRules.router_network.ssid,
				required: true
			},
			{
				name: ['router_network', 'password'],
				label: 'devices.router_network_password',
				permission: 'router_network.password',
				type: 'password',
				validation: this.validationRules.router_network.password
			},
			{
				name: ['router_network', 'priority'],
				label: 'devices.router_network_priority',
				permission: 'router_network.priority',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.networkPriorities,
				bindLabel: 'text',
				bindValue: 'id',
				validation: this.validationRules.router_network.priority
			},
			{
				name: ['online_network', 'ssid'],
				label: 'devices.online_network_ssid',
				permission: 'online_network.ssid',
				type: 'text',
				validation: this.validationRules.online_network.ssid,
				required: true
			},
			{
				name: ['online_network', 'bssid'],
				label: 'devices.online_network_bssid',
				permission: 'online_network.bssid',
				type: 'text',
				validation: this.validationRules.online_network.bssid
			},
			{
				name: ['online_network', 'password'],
				label: 'devices.online_network_password',
				permission: 'online_network.password',
				type: 'password',
				validation: this.validationRules.online_network.password
			},
			{
				name: ['online_network', 'priority'],
				label: 'devices.online_network_priority',
				permission: 'online_network.priority',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.networkPriorities,
				bindLabel: 'text',
				bindValue: 'id',
				validation: this.validationRules.online_network.priority
			},
		];
	}

	prepareBilledKWHrsSettingsForm() {
		this.billedKWHrsSettingsFormFields = [];

		this.billedKWHrsSettingsFormFields.push({
			name: 'charger_efficiency',
			label: 'devices.charger_efficiency',
			permission: 'charger_efficiency',
			type: 'text',
			validation: this.validationRules.charger_efficiency
		});

		this.billedKWHrsSettingsFormFields.push({
			name: 'battery_efficiency',
			label: 'devices.battery_efficiency',
			permission: 'battery_efficiency',
			type: 'text',
			validation: this.validationRules.battery_efficiency
		});

		this.billedKWHrsSettingsFormFields.push(
			{
				name: 'return_factor',
				label: 'devices.return_factor',
				permission: 'return_factor',
				type: 'text',
				validation: this.validationRules.return_factor
			},
		);
	}

	prepareMaintenanceScheduleForm() {
		this.maintenanceScheduleFormFields = [];
		if(this.validationRules.report_ahr) {
			this.maintenanceScheduleFormFields.push(
				{
					name: 'report_ahr_opt',
					label: 'maintenance_schedule.report_ahr_opt',
					permission: 'maintenance_schedule.report_ahr_opt',
					type: 'boolean',
					validation: this.validationRules.report_ahr_opt,
					tooltip: 'report_ahr_opt'
				},
				{
					name: 'report_ahr',
					label: 'maintenance_schedule.report_ahr',
					permission: 'maintenance_schedule.report_ahr',
					type: 'text',
					validation: this.validationRules.report_ahr,
					controlledBy: 'report_ahr_opt'
				},
			);
		}
		if(this.validationRules.report_kwhr) {
			this.maintenanceScheduleFormFields.push(
				{
					name: 'report_kwhr_opt',
					label: 'maintenance_schedule.report_kwhr_opt',
					permission: 'maintenance_schedule.report_kwhr_opt',
					type: 'boolean',
					validation: this.validationRules.report_kwhr_opt,
					tooltip: 'report_kwhr_opt'
				},
				{
					name: 'report_kwhr',
					label: 'maintenance_schedule.report_kwhr',
					permission: 'maintenance_schedule.report_kwhr',
					type: 'text',
					validation: this.validationRules.report_kwhr,
					controlledBy: 'report_kwhr_opt'
				},
			);
		}
		this.maintenanceScheduleFormFields = this.maintenanceScheduleFormFields.concat([
			{
				name: 'report_usage_hours_opt',
				label: this.deviceService.getTranslationKey('maintenance_schedule.report_usage_hours_opt', this.device),
				permission: 'maintenance_schedule.report_usage_hours_opt',
				type: 'boolean',
				validation: this.validationRules.report_usage_hours_opt,
				tooltip: 'report_usage_hours_opt'
			},
			{
				name: 'report_usage_hours',
				label: this.deviceService.getTranslationKey('maintenance_schedule.report_usage_hours', this.device),
				permission: 'maintenance_schedule.report_usage_hours',
				type: 'text',
				validation: this.validationRules.report_usage_hours,
				controlledBy: 'report_usage_hours_opt'
			},
			{
				name: 'report_period_opt',
				label: 'maintenance_schedule.report_period_opt',
				permission: 'maintenance_schedule.report_period_opt',
				type: 'boolean',
				validation: this.validationRules.report_period_opt,
				tooltip: 'report_period_opt'
			},
			{
				name: 'report_period',
				label: 'maintenance_schedule.report_period',
				permission: 'maintenance_schedule.report_period',
				type: 'text',
				validation: this.validationRules.report_period,
				controlledBy: 'report_period_opt'
			}
		]);
	}

	prepareShiftScheduleForm() {
		this.shiftScheduleFormFields = [];

		if (!this.deviceConfig.fields.hasShiftSchedule)
			return;

		this.shiftScheduleFormFields = [
			{
				name: 'inherit_shift_schedule_site_settings',
				label: 'devices.inherit_shift_schedule_site_settings',
				permission: 'inherit_shift_schedule_site_settings',
				type: 'boolean',
			},
			{
				name: 'shift_schedule',
				label: 'devices.shift_schedule',
				permission: 'shift_schedule',
				type: 'dropdown',
				items: this.deviceCommonService.ddLists.scheduledOption,
				bindLabel: 'label',
				bindValue: 'value',
				validation: this.validationRules.shift_schedule,
				visibleIf: (data) => !data.inherit_shift_schedule_site_settings
			},
		];
	}

	onInheritShiftScheduleChange(value: boolean) {
		const field = this.shiftScheduleFormFields.find(
			f => f.name === 'shift_schedule'
		);

		if (field) {
			field.disabled = value;
		}
	}

	prepareMaintenanceScheduleValidation() {
		let rules: any = {
			report_ahr_opt: [{type: 'integer', min: 0, max: 1}],
			report_ahr: [{type: 'integer', min: 1, max: this.deviceService.maxAllowedIntValue}],
			report_kwhr_opt: [{type: 'integer', min: 0, max: 1}],
			report_kwhr: [{type: 'integer', min: 1, max: this.deviceService.maxAllowedIntValue}],
			report_usage_hours_opt: [{type: 'integer', min: 0, max: 1}],
			report_usage_hours: [{type: 'integer', min: 10 * 24, max: 365 * 24}],
			report_period_opt: [{type: 'integer', min: 0, max: 1}],
			report_period: [{type: 'integer', min: 30, max: 1000}],
		};
		if(this.multiDevices) {
			delete rules.report_ahr;
			delete rules.report_kwhr;
		}
		if(this.extraRules) {
			if(this.extraRules.minAhr)
				rules.report_ahr = [{type: 'integer', min: Math.round(this.extraRules.minAhr), max: Math.round(this.extraRules.maxAhr)}];
			if(this.extraRules.minKwhr)
				rules.report_kwhr = [{type: 'integer', min: Math.round(this.extraRules.minKwhr), max: Math.round(this.extraRules.maxKwhr)}];
		}
		return rules;
	}

	prepareValidationRules() {
		const isIMDevice = DeviceFactory.isIMDeviceType(this.device.sct_device_type);
		this.validationRules = this.commonUtil.getValidationRules(isIMDevice);
		this.validationRules = Object.assign(this.validationRules, this.prepareMaintenanceScheduleValidation());
	}

	onChangeBatteryType(type) {
		if(type == this.deviceService.batteryTypesByName.lithuim_ion) {
			this.device.vpc = 3;
			this.forceDirtyFields.push('vpc');
		} else if(type == this.deviceService.batteryTypesByName.lead) {
			this.device.vpc = 2;
			this.forceDirtyFields.push('vpc');
		}
	}
	onChangeRemoteServerIp(type) {
		const serverIpsIdMap = _.indexBy(this.deviceCommonService.getRemoteServerType(this.device.fw_version, this.isIMDevice, this.device.sct_device_type), 'id');
		const ipObj = serverIpsIdMap[type];

		if(ipObj.domain)
			this.device.remoter_server_ip = ipObj.domain;
		else
			this.device.remoter_server_ip = this.oldDevice.remoter_server_ip;

		// if(this.device.is_dev_device)
		// 	this.device.enc_code = serverIpsIdMap.dev.encCode;
		// else
			this.device.enc_code = ipObj.encCode;
		this.device.remoter_server_port = ipObj.port;
	}

	// a CHARGlink Charger Manufacturer is picked from the managed list, "Other" shows the free text input (ST-2708)
	getTruckManufacturerFields(truckManufacturersItem) {
		if (!this.deviceConfig.isCharglink)
			return [truckManufacturersItem];

		const optionField = {
			name: 'truck_manufacturer_option',
			label: truckManufacturersItem.label,
			permission: 'truck_manufacturer',
			type: 'dropdown',
			items: [],
			bindLabel: 'label',
			bindValue: 'value',
			clearable: true,
			tooltip: truckManufacturersItem.tooltip
		};

		const otherField = {
			...truckManufacturersItem,
			// sits right under the dropdown, the label is still used by the validation messages (ST-2746)
			hideLabel: true,
			tooltip: null,
			visibleIf: (device) => device.truck_manufacturer_option === this.chargerManufacturerOtherOption
		};

		if (this.chargerManufacturerNames)
			this.setChargerManufacturerOptions(optionField);
		else
			this.loadChargerManufacturerOptions(optionField);

		return [optionField, otherField];
	}

	loadChargerManufacturerOptions(optionField) {
		this.chargerManufacturersService.getManufacturers().subscribe({
			next: (manufacturers: ChargerManufacturer[]) => {
				this.chargerManufacturerNames = (manufacturers || []).map(manufacturer => manufacturer.name);
				this.setChargerManufacturerOptions(optionField);
			},
			// the interceptor already shows the error; "Other" stays usable and the list is requested again next time
			error: () => this.setChargerManufacturerOptions(optionField, [])
		});
	}

	// the list comes sorted from the server, "Other" is added after it so it always stays last
	setChargerManufacturerOptions(optionField, names: string[] = this.chargerManufacturerNames) {
		optionField.items = [
			...names.map(name => ({ label: name, value: name })),
			{ label: this.translate.instant('charger_manufacturers.other'), value: this.chargerManufacturerOtherOption }
		];

		this.setChargerManufacturerOption(names);
	}

	setChargerManufacturerOption(names: string[] = this.chargerManufacturerNames) {
		// a value that is not in the list opens on "Other" with the value shown as is
		const manufacturer = this.device.truck_manufacturer;
		let option = null;
		if (manufacturer)
			option = names.includes(manufacturer) ? manufacturer : this.chargerManufacturerOtherOption;

		// oldDevice was copied before the form was built, without it clearing the dropdown is not seen as a change
		this.device.truck_manufacturer_option = option;
		this.oldDevice.truck_manufacturer_option = option;
	}

	// the dropdown only lives on the page, the picked option becomes the Charger Manufacturer that is saved
	applyChargerManufacturerOption(dirtyFields) {
		if (!('truck_manufacturer_option' in dirtyFields))
			return;

		const option = dirtyFields.truck_manufacturer_option;
		delete dirtyFields.truck_manufacturer_option;

		// with "Other" the free text input carries the value, it is already in dirtyFields when it was changed
		if (option === this.chargerManufacturerOtherOption)
			return;

		const manufacturer = option || '';
		this.device.truck_manufacturer = manufacturer;

		if (manufacturer != this.oldDevice.truck_manufacturer)
			dirtyFields.truck_manufacturer = manufacturer;
		else
			delete dirtyFields.truck_manufacturer;
	}

	onDropdownChanged(event) {
		const field = Array.isArray(event.field) ? event.field.join('.') : event.field;
		switch(field) {
			case 'battery_type':
				this.onChangeBatteryType(event.value);
				break;
			case 'remoter_server_ip_options':
				this.onChangeRemoteServerIp(event.value);
				break;
			case 'ct_ratio':
				this.onCtRatioChanged(event.value);
				break;
			case '_virtual_service_type':
				this.restartRequired = true;
				break;
			case 'voltage_reference':
				this.handleChangeVoltage_reference(event.value);
				break;
			case 'wiring_mode':
				this.onWiringModeChanged(event.value);
				break;
			case 'inherit_shift_schedule_site_settings':
				this.onInheritShiftScheduleChange(event.value);
				break;
			case 'power_view_sn':
				this.onPanelIdChanged(event.value);
				break;
		}
	}

	get canScanWifiNetworks(): boolean {
		return !this.multiDevices && !!this.device.connected && !!this.device.enable_wifi_sta
			&& !!this.usersService.hasAccessPermission(this.enterprisePermissions, 'online_network.ssid', 'write');
	}

	scanWifiNetworks(refresh?) {
		if(refresh)
			this.availableWifiNetworksModal.hide();
		this.availableWifiNetworks = [];
		this.deviceService.sendCommand(this.device.mac_address, 'scanWifiNetworks').subscribe((res: any) => {
			this.availableWifiNetworks = this.deviceService.formatWifiNetworks(res.networks);
			this.availableWifiNetworksModal.show();
		});
	}

	selectWifiNetwork(network) {
		this.availableWifiNetworksModal.hide();
		this.selectWifiNetworksModal.show();
		this.selectedWifiNetwork = network;
	}

	updateWifiNetwork() {
		let valuesToChange = {
			'online_network.ssid': this.selectedWifiNetwork.ssid,
			'online_network.bssid': this.selectedWifiNetwork.bssid,
		};

		let isOpen = this.deviceService.formatWifiAuthMode(this.selectedWifiNetwork.auth_mode) == this.deviceService.wifiAuthMode.open;
		if(isOpen || this.device.online_network.ssid != this.selectedWifiNetwork.ssid) {
			valuesToChange['online_network.password'] = '';
		}

		for(let model in valuesToChange) {
			let modelArr = model.split('.');
			this.device[modelArr[0]][modelArr[1]] = valuesToChange[model];
			this.forceDirtyFields.push(model);
		}
	}

	prepareMaintenanceScheduleData() {
		if(!this.multiDevices && this.maintenanceSchedule.report_usage_hours === undefined) {
			let forceFields = {
				report_usage_hours_opt: true,
				report_usage_hours: 30 * 24
			};
			this.forceDirtyFields = Object.keys(forceFields);
			this.maintenanceSchedule = Object.assign(this.maintenanceSchedule, forceFields);
		}
	}

	fillStudiesField() {
		let fields = [];

		if (!this.deviceConfig.couldHaveStudy)
			return fields;

		if (this.deviceTypeService.isStudyDevice(this.device))
			fields = [
				{
					name: 'study_name',
					label: 'devices.study_name',
					permission: 'study_name',
					type: 'label',
					validation: this.validationRules.study_name
				},
				{
					name: 'study_start_event_id',
					label: 'devices.study_start_event_id',
					permission: 'study_start_event_id',
					type: 'label',
					validation: this.validationRules.study_start_event_id,
				},
			];

		if (!this.usersService.hasAccessFunction('shipment_management')) {
			fields.push(
				{
					name: 'application_type',
					label: 'studies.power_study',
					type: 'label',
					value: this.translate.instant(`application_type.${this.device.application_type}`),
					permission: 'read'
				},
			);
			delete this.changesStack['application_type'];
		} else {
			fields.push(
				{
					name: 'application_type',
					label: 'studies.power_study',
					permission: 'application_type',
					type: 'dropdown',
					items: DeviceFactory.PS_APPLICATION_TYPES,
					bindLabel: 'name',
					bindValue: 'id',
					validation: this.validationRules.application_type
				},
			);
		}

		return fields;
	}

	showMultiPointCal(data) {
		return Object.keys(data).length > 0;
	}

	removeChangeStack(dataToUpdate, confirmed=true) {
		if (confirmed) {
			this.removedChangesStackInfo = dataToUpdate;
			if (dataToUpdate.userId != this.currentUser.id)
				this.confirmDeleteStack = true;
			return this.deleteChangeStack.show();
		}

		const {fieldName, commandId} = dataToUpdate;
		const mappedField = this.mapRemoveChangeStackFields(fieldName);

		this.deviceService.removeChangeStack(mappedField, commandId, this.device.mac_address).subscribe((response:any) => {
			switch(response) {
				case 1:
					Array.isArray(fieldName)? delete this.changesStack[fieldName[0]][fieldName[1]] : delete this.changesStack[fieldName];
					// the dropdown and the Other input share one queued change, both stop showing it (ST-2746)
					if (fieldName == 'truck_manufacturer_option' || fieldName == 'truck_manufacturer') {
						delete this.changesStack.truck_manufacturer;
						delete this.changesStack.truck_manufacturer_option;
					}
					this.notificationMessage.setMessage('globalSuccessMsg', {clearOnXTimeNavigate: 1});
					break;
				case 2:
					this.notificationMessage.setMessage('translate|settings.queue_change_executed', {clearOnXTimeNavigate: 1, type: 'danger'});
					break;
				default:
					this.notificationMessage.setMessage('globalErrMsg', {clearOnXTimeNavigate: 1});
					break;
			}
		});
	};

	mapRemoveChangeStackFields(fieldName: string) {
		switch (fieldName) {
			case 'rtLogFrequency':
				fieldName = 'rt_log_frequency';
				break;
			case 'truck_manufacturer_option':
				fieldName = 'truck_manufacturer';
				break;
			default:
				break;
		}

		return fieldName;
	}

	isFWSupportField(field: string) {
		switch (field) {
			case 'disable_external_rtc':
			case 'disable_xtra':
			case 'lift_current_threshold_percentage':
			case 'lift_current_threshold_delta_percentage':
			case 'current_lift_upper_threshold':
			case 'current_lift_lower_threshold':
				return this.device.fw_version >= 2.36;
			case 'enable_current_mask':
				return this.device.fw_version >= 2.3710;
			case 'max_battery_temperature':
			case 'cool_down_temperature':
				return this.device.fw_version >= 2.4401;
			case 'rt_log_frequency':
				return this.device.fw_version >= 2.4410;
			case 'meter_sn':
				return this.device.fw_version > 1.22;
			case 'sct_pre_configured':
				return this.device.fw_version >= 1.24;
			case 'hall_effect_sensor_type':
				return this.device.fw_version >= 1.1000;
			default:
				return false;
		};
	}

	updateEnabledWiresToDefault() {
		const wiringModeSettings = this.deviceCommonService.ddLists.wiringModeSettings;
		if (!(this.device.wiring_mode in wiringModeSettings))
			this.device.wiring_mode = this.defaultWiringMode;

		const enabledWiresValues = (wiringModeSettings[this.device.wiring_mode].enabledWiresOptions).map((item: any) => item.value);
		if (!enabledWiresValues.includes(this.device.enabled_wires))
			this.device.enabled_wires = wiringModeSettings[this.device.wiring_mode].enabledWiresDefault;
	}

	handleDifferentCtRatio() {
		const { is_rct, ct_ratio } = this.device;

		const isCtRatioInvalid = (
			(is_rct == 1 && !this.deviceCommonService.ddLists.ctRatioRogowskiType.some(item => item.id == ct_ratio)) ||
			(is_rct == 0 && !this.deviceCommonService.ddLists.ctRatioOptions.some(item => item.id == ct_ratio))
		);

		if (isCtRatioInvalid)
			this.device.ct_ratio = null;
	}

	onCtRatioChanged(value: number) {
		// Update over_current_threshold value
		const overCurrentThresholdValue = this.oldDevice.over_current_threshold || 0;

		const factor = value / this.oldDevice.ct_ratio;
		const overCurrentThreshold = factor * overCurrentThresholdValue;

		this.device.over_current_threshold = overCurrentThreshold;
		this.forceDirtyFields.push('over_current_threshold');
		this.onCtRatioChangedOldValue = value;
	}

	handleVoltageReferenceField(wiringModeValue: number, setAsDirty = false) {
		const voltageReferenceField = this.deviceSettingsFormFields.findIndex((field) => field.name === 'voltage_reference');
		if (voltageReferenceField !== -1)
			this.deviceSettingsFormFields[voltageReferenceField].items = this.getVoltageReferenceOptions(wiringModeValue);

		const wiringModeSettings = this.deviceCommonService.ddLists.wiringModeSettings[wiringModeValue];
		const voltageReferenceOptions = this.deviceCommonService.ddLists.voltageReferenceOptions;

		if (wiringModeSettings && wiringModeSettings.voltageReferenceDefault) {
			this.device.voltage_reference = voltageReferenceOptions[wiringModeSettings.voltageReferenceDefault].value;
			if (setAsDirty)
				this.forceDirtyFields.push('voltage_reference');
		}

		return;
	}

	updateDeviceThresholdInfo(method: "divide" | "multi", setAsDirty = false) {
		const underVoltageThreshold = this.device.under_voltage_threshold;
		const overVoltageThreshold = this.device.over_voltage_threshold;

		// console.log(underVoltageThreshold, overVoltageThreshold);
		
		this.device.under_voltage_threshold = this.commonUtil.calcVoltageReference(underVoltageThreshold, method).toFixed(2);
		this.device.over_voltage_threshold = this.commonUtil.calcVoltageReference(overVoltageThreshold, method).toFixed(2);

		// console.log(this.device.under_voltage_threshold, this.device.over_voltage_threshold);

		if (setAsDirty) {
			this.forceDirtyFields.push('under_voltage_threshold');
			this.forceDirtyFields.push('over_voltage_threshold');
		}
	}

	updateThresholdField(voltageReference = null) {
		const voltage_reference = typeof(voltageReference) == 'number' ? voltageReference : this.device.voltage_reference;

		const overVoltageThresholdFieldIndex = this.deviceSettingsFormFields.findIndex(f => f.name === "over_voltage_threshold");
		const underVoltageThresholdFieldIndex = this.deviceSettingsFormFields.findIndex(f => f.name === "under_voltage_threshold");

		if (overVoltageThresholdFieldIndex !== -1)
			this.deviceSettingsFormFields[overVoltageThresholdFieldIndex].label = voltage_reference ? this.deviceService.translate('devices.over_voltage_threshold_ln', this.device) : this.deviceService.translate('devices.over_voltage_threshold_ll', this.device);

		if (underVoltageThresholdFieldIndex !== -1)
			this.deviceSettingsFormFields[underVoltageThresholdFieldIndex].label = voltage_reference ? this.deviceService.translate('devices.under_voltage_threshold_ln', this.device) : this.deviceService.translate('devices.under_voltage_threshold_ll', this.device);
	}

	updateThreshold(voltageReferenceDefault: any) {
		const voltageReferenceOptions = this.deviceCommonService.ddLists.voltageReferenceOptions;
		if (voltageReferenceDefault) {
			if (voltageReferenceOptions[voltageReferenceDefault].value === this.deviceService.lineToLine && this.lastVoltageRefOption !== this.deviceService.lineToLine) {
				this.lastVoltageRefOption = this.deviceService.lineToLine;
				this.updateDeviceThresholdInfo('multi', true);
			} else if (voltageReferenceOptions[voltageReferenceDefault].value === this.deviceService.lineToNeutral && this.lastVoltageRefOption !== this.deviceService.lineToNeutral) {
				this.lastVoltageRefOption = this.deviceService.lineToNeutral;
				this.updateDeviceThresholdInfo('divide', true);
			}

			return this.updateThresholdField()
		}
	}
	
	handleVoltageDetectionThreshold(wiringModeValue: number) {
		let voltageReferenceDefault = this.deviceCommonService.ddLists.wiringModeSettings[wiringModeValue].voltageReferenceDefault;
		const voltageReferenceOptions = this.deviceCommonService.ddLists.voltageReferenceOptions;
		const deviceReference =  Object.keys(voltageReferenceOptions).find((key:any) => voltageReferenceOptions[key].value == this.device?.voltage_reference);
		voltageReferenceDefault = voltageReferenceDefault ? voltageReferenceDefault : deviceReference;

		this.updateThreshold(voltageReferenceDefault);
	}

	handleChangeVoltage_reference(voltageReference: any) {
		const voltageReferenceOptions = this.deviceCommonService.ddLists.voltageReferenceOptions;
		const deviceReference =  Object.keys(voltageReferenceOptions).find((key:any) => voltageReferenceOptions[key].value == voltageReference);
		if (deviceReference) {
			this.device.voltage_reference = voltageReferenceOptions[deviceReference].value;
			this.forceDirtyFields.push('voltage_reference');
		}

		this.updateThreshold(deviceReference);
	}

	onWiringModeChanged(wiringModeValue: any) {
		// this.handleEnabledWiresField(wiringModeValue);
		this.handleVoltageReferenceField(wiringModeValue, true);
		this.handleVoltageDetectionThreshold(wiringModeValue);
		this.setLabelUnderInputWiringModeField(wiringModeValue);
	}

	setLabelUnderInputWiringModeField(value: number) {
		const wiringModeFieldIndex = this.deviceSettingsFormFields.findIndex(f => f.name === "wiring_mode");
		if (wiringModeFieldIndex !== -1) {
			const wiringModeSettings = this.deviceCommonService.ddLists.wiringModeSettings[value];
			this.deviceSettingsFormFields[wiringModeFieldIndex].labelUnderInput = wiringModeSettings.wiringModeNote || '';
		}
	}

	highlightInvalidField(fieldName: string) {
		const form = this.el.nativeElement;
		const element = form.querySelectorAll(`[name=${fieldName}]`);
		if (element && element[0])
			this.renderer.addClass(element[0], 'invalid-input');
	}

	resetVoltageRelatedFields() {
		if (!this.isIMDevice)
			return;

		if (this.device?.voltage_reference === this.deviceService.lineToLine)
			this.updateDeviceThresholdInfo('divide', false);

		this.updateThresholdField(this.oldDevice.voltage_reference);
		this.handleVoltageReferenceField(this.oldDevice.wiring_mode);
		this.setLabelUnderInputWiringModeField(this.oldDevice.wiring_mode);

		if (this.lastVoltageRefOption === this.deviceService.lineToNeutral && this.actualVoltageValue == this.deviceService.lineToLine)
			this.device.voltage_reference = this.deviceService.lineToLine;
		else if (this.lastVoltageRefOption === this.deviceService.lineToLine && this.actualVoltageValue == this.deviceService.lineToNeutral)
			this.device.voltage_reference = this.deviceService.lineToNeutral;
	}

	prepareVoltageRelatedFields() {
		if (!this.isIMDevice)
			return;

		this.handleDifferentCtRatio();
		this.updateEnabledWiresToDefault();

		if (this.device?.voltage_reference === this.deviceService.lineToLine)
			this.updateDeviceThresholdInfo('multi');

		this.actualVoltageValue = this.device?.voltage_reference || 0;
		this.lastVoltageRefOption = this.device?.voltage_reference || 0;
	}

	deviceHasPassword(): boolean {
		return !!this.device.device_password_enc;
	}

	requestRevealDevicePassword() {
		this.revealDevicePasswordConfirmModal.show();
	}

	unblockDeviceConnection() {
		this.deviceService.unblockDeviceConnection(this.device.mac_address).subscribe(() => {
			this.device.is_blocked_connection = false;
			this.device.blocked_connection_until = null;
			this.notificationMessage.setMessage('globalSuccessMsg', { clearOnXTimeNavigate: 1 });
		});
	}

	confirmRevealDevicePassword() {
		this.revealDevicePasswordConfirmModal.hide();
		this.sitesService.requestRevealPassword(
			this.currentSite.id,
			this.currentSite.customer_id,
			'device',
			this.device.mac_address
		).subscribe((response: any) => {
			if (response.api_status == 2)
				return this.notificationMessage.setMessage('translate|password_reveal.pending_request_exists', { clearOnXTimeNavigate: 1 });
		
			this.notificationMessage.setMessage('translate|password_reveal.request_submitted', {
					type: 'success',
					clearOnXTimeNavigate: 1
			});
		});
	}

	/**
	 * Unified filter method for all form fields based on device capabilities
	 * Filters deviceSettings, batterySettings, and calibration fields
	 */
	filterFields(fields?: any[], context?: 'deviceSettings' | 'batterySettings' | 'calibration'): any[] {
		// If called without parameters, filter all form fields
		if (!fields) {
			this.deviceSettingsFormFields = this.filterFields(this.deviceSettingsFormFields, 'deviceSettings');
			this.batterySettingsFormFields = this.filterFields(this.batterySettingsFormFields, 'batterySettings');
			this.calFormFields = this.filterFields(this.calFormFields, 'calibration');
			return;
		}

		// Define field categories
		const fieldCategories = {
			// Device Settings fields
			deviceTemperature: ['has_temperature_sensor'],
			deviceWaterLevel: ['has_water_level', 'time_hysteresis'],
			deviceHallEffect: ['hall_effect_sensor_type'],
			deviceEqVoltage: ['eq_voltage', 'eq_duration'],
			deviceEqCurrentRate: ['eq_current_rate'],
			
			// Battery Settings EQ-related fields
			batteryEq: [
				'fi_duration', 'eq_duration', 'eq_voltage', 'fi_target_voltage',
				'eq_current_rate', 'fi_current_rate', 'fi_dt', 'fi_dv'
			],
			
			// Battery Settings temperature-related fields
			batteryTemperature: [
				'battery_temperature_compensation_in_mv', 'max_battery_temperature', 'cool_down_temperature'
			],
			
			// Calibration temperature-related fields
			calibrationTemperature: [
				'temperature_beta', 'temperature_res_dividor', 'temperature_res_drift', 'temperature_res_dividor_drift'
			],
			
			// Calibration water level-related fields
			calibrationWaterLevel: [
				'probe_drift_adc', 'probe_scale_adc', 'high_probe_voltage'
			]
		};

		return fields.filter(field => {
			const fieldName = field.name;

			// Filter based on context
			if (context === 'deviceSettings') {
				// Device Settings specific filters
				if (fieldCategories.deviceTemperature.includes(fieldName) && !this.deviceConfig.fields.hasTemperatureSensor) {
					return false;
				}
				if (fieldCategories.deviceWaterLevel.includes(fieldName) && !this.deviceConfig.fields.hasWaterLevel) {
					return false;
				}
				if (fieldCategories.deviceHallEffect.includes(fieldName) && !this.deviceConfig.fields.hasHallEffect) {
					return false;
				}
				if (fieldCategories.deviceEqVoltage.includes(fieldName) && !this.deviceConfig.fields.eqVoltage) {
					return false;
				}
				if (fieldCategories.deviceEqCurrentRate.includes(fieldName) && !this.deviceConfig.fields.eqCurrentRate) {
					return false;
				}
			} else if (context === 'batterySettings') {
				// Battery Settings specific filters
				if (fieldCategories.batteryEq.includes(fieldName) && this.deviceConfig.fields.hasEq === false) {
					return false;
				}
				if (fieldCategories.batteryTemperature.includes(fieldName) && this.deviceConfig.fields.hasTemperatureSensor === false) {
					return false;
				}
			} else if (context === 'calibration') {
				// Calibration specific filters
				if (fieldCategories.calibrationTemperature.includes(fieldName) && this.deviceConfig.fields.hasTemperatureSensor === false) {
					return false;
				}
				if (fieldCategories.calibrationWaterLevel.includes(fieldName) && this.deviceConfig.fields.hasWaterLevel === false) {
					return false;
				}
			}

			return true;
		});
	}

	formatBatterySettingsValues() {
		const batteryFields = [
			'cv_target_voltage',
			'fi_target_voltage',
			'eq_voltage',
			'trickle_current_rate',
			'cc_rate',
			'cv_end_current_rate',
			'fi_current_rate',
			'eq_current_rate'
		];

		for (const field of batteryFields) {
			if (this.device[field] !== undefined && this.device[field] !== null) {
				this.device[field] = Number(Number(this.device[field]).toFixed(2));
			}
		}
	}

	updateEventTableColumnsVisibility(): void {
		const stored = localStorage.getItem(this.EVENT_TABLE_COLUMNS_KEY);
		if (!stored) 
			return;

		let columns: { key: string; hidden: boolean; [key: string]: any }[];
		try {
			columns = JSON.parse(stored);
		} catch {
			return;
		}

		if (!Array.isArray(columns))
			return;

		const waterLevelColumns    = ['water_level_exists', 'water_level_high'];
		const temperatureColumns   = ['max_temperature_recorded', 'max_temperature_recorded_timestamp', 'temperature_exists'];

		const hasWaterLevel        = !!this.device.has_water_level;
		const hasTemperatureSensor = !!this.device.has_temperature_sensor;

		let changed = false;

		for (const col of columns) {
			if (waterLevelColumns.includes(col.key)) {
				const shouldBeHidden = !hasWaterLevel;
				if (col.hidden !== shouldBeHidden) {
					col.hidden = shouldBeHidden;
					changed = true;
				}
			}
			if (temperatureColumns.includes(col.key)) {
				const shouldBeHidden = !hasTemperatureSensor;
				if (col.hidden !== shouldBeHidden) {
					col.hidden = shouldBeHidden;
					changed = true;
				}
			}
		}

		if (changed)
			localStorage.setItem(this.EVENT_TABLE_COLUMNS_KEY, JSON.stringify(columns));
	}

	ngOnDestroy() {
		if (this.getSitePanelIdsSub)
			this.getSitePanelIdsSub.unsubscribe();
	}
}
